import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { 
  Plus, 
  Search, 
  LayoutDashboard, 
  Users, 
  Briefcase, 
  FileText, 
  Settings, 
  Bell,
  Scale,
  ChevronRight,
  X,
  TrendingUp,
  Clock,
  ArrowUpRight,
  ArrowDownRight,
  DollarSign,
  Download,
  Filter,
  BarChart3,
  Mail,
  Phone,
  MapPin,
  ExternalLink,
  UserCheck,
  Building2,
  MoreVertical,
  LogIn,
  LogOut,
  Globe,
  Bot,
  FileSignature,
  Send,
  CheckCircle,
  AlertCircle,
  Trash2,
  Moon,
  Sun,
  ClipboardCheck,
  Calculator
} from 'lucide-react';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import Calendar from './components/Calendar';
import CrawlerModule from './components/CrawlerModule';
import LegalAIModule from './components/LegalAIModule';
import LoginModule from './components/LoginModule';
import FinanceiroModule from './components/FinanceiroModule';
import ConsultaProcessual from './components/ConsultaProcessual';
import HomologacaoModule from './components/HomologacaoModule';
import DiferencaSalarialModule from './components/DiferencaSalarialModule';

const App = () => {
  const [activeTab, setActiveTab] = useState('clientes');
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    try { return !!JSON.parse(localStorage.getItem('lex-user')); } catch { return false; }
  });
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('lex-user')) || null; } catch { return null; }
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcessoModalOpen, setIsProcessoModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const searchRef = useRef(null);
  const [filterType, setFilterType] = useState('Todos');

  const [processos, setProcessos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const apiBaseUrl = process.env.REACT_APP_API_URL || '';

  const [newClienteNome, setNewClienteNome] = useState('');
  const [newClienteTipo, setNewClienteTipo] = useState('PF');
  const [newClienteEmail, setNewClienteEmail] = useState('');
  const [newClienteTel, setNewClienteTel] = useState('');
  const [newClienteCidade, setNewClienteCidade] = useState('');
  const [notification, setNotification] = useState({type: '', message: '', visible: false});
  const [notificacoes, setNotificacoes] = useState([]);
  const [isNotifDropdownOpen, setIsNotifDropdownOpen] = useState(false);
  const [prazoModal, setPrazoModal] = useState(null); // { notif, prazo_tipo, prazo_dias, prazo_contagem, prazo_data_limite }
  const [prazoEditDias, setPrazoEditDias] = useState('');
  const [prazoEditContagem, setPrazoEditContagem] = useState('uteis');
  const [prazoSalvando, setPrazoSalvando] = useState(false);
  const [dossierCliente, setDossierCliente] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [docModal, setDocModal] = useState(false);
  const [docSigModal, setDocSigModal] = useState(null); // documento selecionado para solicitar assinatura
  const [docTitulo, setDocTitulo] = useState('');
  const [docTipo, setDocTipo] = useState('Contrato');
  const [docConteudo, setDocConteudo] = useState('');
  const [docCliente, setDocCliente] = useState('');
  const [docProcesso, setDocProcesso] = useState('');
  const [sigNome, setSigNome] = useState('');
  const [sigEmail, setSigEmail] = useState('');
  const [sigEnviando, setSigEnviando] = useState(false);
  const [docAssinaturas, setDocAssinaturas] = useState([]);
  const [docArquivoBase64, setDocArquivoBase64] = useState('');
  const [docArquivoNome, setDocArquivoNome] = useState('');
  const [docEnviarModal, setDocEnviarModal] = useState(null); // documento selecionado para enviar por email
  const [docEnviarEmail, setDocEnviarEmail] = useState('');
  const [docEnviarSending, setDocEnviarSending] = useState(false);
  const notifRef = useRef(null);

  const [newProcessoNumero, setNewProcessoNumero] = useState('');
  const [newProcessoCliente, setNewProcessoCliente] = useState('');
  const [newProcessoTipo, setNewProcessoTipo] = useState('');
  const [newProcessoNatureza, setNewProcessoNatureza] = useState('');
  const [newProcessoData, setNewProcessoData] = useState('');
  const [newProcessoStatus, setNewProcessoStatus] = useState('Ativo');
  const [newProcessoValor, setNewProcessoValor] = useState('');
  const [newProcessoOrigem, setNewProcessoOrigem] = useState('Interno');
  const [newProcessoNumeroJudicial, setNewProcessoNumeroJudicial] = useState('');
  
  const [sysConfig, setSysConfig] = useState({ update_hour: '08', update_enabled: '1', update_mode: 'scheduled', update_interval_hours: '6', last_auto_update: '', notif_emails: '', notif_prazo_dias_antes: '3' });
  const [configSaving, setConfigSaving] = useState(false);
  const [notifEmailsSaving, setNotifEmailsSaving] = useState(false);

  const [usuarios, setUsuarios] = useState([]);
  const [usuarioModal, setUsuarioModal] = useState(null); // null = fechado, {} = novo, {id,...} = edição
  const [usuarioForm, setUsuarioForm] = useState({ nome: '', username: '', password: '', role: 'advogado' });
  const [usuarioSalvando, setUsuarioSalvando] = useState(false);

  const [googleSignedIn, setGoogleSignedIn] = useState(false);
  const [calendarIntegrated, setCalendarIntegrated] = useState(false);
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('lex-dark') === '1');
  const [reportDateFrom, setReportDateFrom] = useState('');
  const [reportDateTo, setReportDateTo] = useState('');
  const [reportStatus, setReportStatus] = useState('Todos');
  const [reportTipo, setReportTipo] = useState('Todos');
  const [reportCliente, setReportCliente] = useState('Todos');

  const loadDocumentos = useCallback(async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/api/documentos`);
      if (res.ok) setDocumentos(await res.json());
    } catch(e) {}
  }, [apiBaseUrl]);

  const loadData = useCallback(async () => {
    try {
      const [clientesRes, processosRes] = await Promise.all([
        fetch(`${apiBaseUrl}/api/clientes`),
        fetch(`${apiBaseUrl}/api/processos`),
      ]);

      if (!clientesRes.ok || !processosRes.ok) {
        throw new Error('Erro ao carregar dados do servidor.');
      }

      const [clientesData, processosData] = await Promise.all([
        clientesRes.json(),
        processosRes.json(),
      ]);

      setClientes(clientesData);
      setProcessos(processosData);
    } catch (error) {
      console.error(error);
    }
  }, [apiBaseUrl]);

  const loadNotificacoes = useCallback(async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/api/notificacoes`);
      if (res.ok) setNotificacoes(await res.json());
    } catch (e) { /* silencioso */ }
  }, [apiBaseUrl]);

  const loadUsuarios = useCallback(async () => {
    if (!user || user.role !== 'administrador') return;
    try {
      const res = await fetch(`${apiBaseUrl}/api/usuarios?solicitanteRole=${user.role}`);
      if (res.ok) setUsuarios(await res.json());
    } catch (e) { /* silencioso */ }
  }, [apiBaseUrl, user]);

  const salvarUsuario = async () => {
    if (!usuarioForm.username || (!usuarioForm.id && !usuarioForm.password)) {
      setNotification({ type: 'error', message: 'Usuário e senha são obrigatórios.', visible: true });
      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
      return;
    }
    setUsuarioSalvando(true);
    try {
      const url = usuarioForm.id ? `${apiBaseUrl}/api/usuarios/${usuarioForm.id}` : `${apiBaseUrl}/api/usuarios`;
      const res = await fetch(url, {
        method: usuarioForm.id ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...usuarioForm, solicitanteRole: user.role }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao salvar usuário.');
      setUsuarioModal(null);
      setUsuarioForm({ nome: '', username: '', password: '', role: 'advogado' });
      await loadUsuarios();
      setNotification({ type: 'success', message: 'Usuário salvo!', visible: true });
      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
    } catch (e) {
      setNotification({ type: 'error', message: e.message, visible: true });
      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
    } finally {
      setUsuarioSalvando(false);
    }
  };

  const excluirUsuario = async (u) => {
    if (!window.confirm(`Excluir o usuário "${u.nome || u.username}"?`)) return;
    try {
      const res = await fetch(`${apiBaseUrl}/api/usuarios/${u.id}?solicitanteRole=${user.role}&solicitanteId=${user.id}`, { method: 'DELETE' });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao excluir usuário.');
      await loadUsuarios();
    } catch (e) {
      setNotification({ type: 'error', message: e.message, visible: true });
      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
    }
  };

  useEffect(() => {
    loadData();
    loadNotificacoes();
    loadDocumentos();
    fetch(`${apiBaseUrl}/api/config`)
      .then(r => r.json())
      .then(cfg => setSysConfig(prev => ({ ...prev, ...cfg })))
      .catch(() => {});
    const interval = setInterval(loadNotificacoes, 60000);
    // Refresh automático: mantém clientes/processos/documentos atualizados sem precisar de F5
    const refreshInterval = setInterval(() => {
      loadData();
      loadDocumentos();
    }, 30000);
    return () => { clearInterval(interval); clearInterval(refreshInterval); };
  }, [loadData, loadNotificacoes, loadDocumentos]);

  useEffect(() => {
    if (activeTab !== 'settings') return;
    loadUsuarios();
    const interval = setInterval(loadUsuarios, 30000);
    return () => clearInterval(interval);
  }, [activeTab, loadUsuarios]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isExportDropdownOpen && !event.target.closest('.export-dropdown')) {
        setIsExportDropdownOpen(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchFocused(false);
      }
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setIsNotifDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isExportDropdownOpen, isNotifDropdownOpen]);

  const marcarNotifLida = async (id) => {
    await fetch(`${apiBaseUrl}/api/notificacoes/${id}/lida`, { method: 'PATCH' });
    setNotificacoes(prev => prev.map(n => n.id === id ? { ...n, lida: 1 } : n));
  };

  const marcarTodasLidas = async () => {
    await fetch(`${apiBaseUrl}/api/notificacoes/lidas/todas`, { method: 'PATCH' });
    setNotificacoes(prev => prev.map(n => ({ ...n, lida: 1 })));
  };

  const abrirModalPrazo = (notif) => {
    if (!notif.prazo_tipo) { marcarNotifLida(notif.id); return; }
    setPrazoModal(notif);
    setPrazoEditDias(String(notif.prazo_dias || ''));
    setPrazoEditContagem(notif.prazo_contagem || 'uteis');
    setIsNotifDropdownOpen(false);
  };

  const calcularDataLimiteFrontend = (dias, contagem) => {
    // Cálculo simplificado no frontend (sem feriados) — o backend faz o cálculo preciso
    const hoje = new Date();
    let cursor = new Date(hoje);
    cursor.setDate(cursor.getDate() + 1); // começa no dia seguinte
    if (contagem === 'corridos') {
      cursor.setDate(cursor.getDate() + Number(dias) - 1);
    } else {
      let contados = 0;
      while (contados < Number(dias)) {
        const dow = cursor.getDay();
        if (dow !== 0 && dow !== 6) contados++;
        if (contados < Number(dias)) cursor.setDate(cursor.getDate() + 1);
      }
    }
    return cursor.toLocaleDateString('pt-BR');
  };

  const confirmarPrazo = async () => {
    if (!prazoModal || !prazoEditDias) return;
    setPrazoSalvando(true);
    try {
      // Busca data-limite precisa no backend
      const resCalc = await fetch(`${apiBaseUrl}/api/prazos/calcular`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data_inicio: new Date().toISOString(), dias: Number(prazoEditDias), contagem: prazoEditContagem }),
      });
      const calc = await resCalc.json();
      const dataLimite = calc.data_limite || new Date().toISOString().split('T')[0];
      const dataLimiteFormatada = calc.data_limite_formatada || dataLimite;

      // Cria tarefa
      await fetch(`${apiBaseUrl}/api/tarefas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          titulo: `[PRAZO] ${prazoModal.prazo_tipo} — ${prazoModal.processo_numero}`,
          descricao: `Prazo: ${prazoEditDias} dias ${prazoEditContagem === 'uteis' ? 'úteis' : 'corridos'}. Limite: ${dataLimiteFormatada}. Cliente: ${prazoModal.cliente}.`,
          processo_id: prazoModal.processo_id,
          status: 'A Fazer',
          prioridade: 'Alta',
          data_entrega: dataLimite,
        }),
      });

      // Cria evento na agenda
      await fetch(`${apiBaseUrl}/api/agenda`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          titulo: `[PRAZO] ${prazoModal.prazo_tipo} — ${prazoModal.processo_numero}`,
          data_hora: `${dataLimite}T09:00:00`,
          processo_id: prazoModal.processo_id,
          descricao: `Prazo processual. Cliente: ${prazoModal.cliente}`,
          tipo: 'Prazo',
        }),
      });

      // Marca notificação como lida e confirmada
      await fetch(`${apiBaseUrl}/api/notificacoes/${prazoModal.id}/lida`, { method: 'PATCH' });
      setNotificacoes(prev => prev.map(n => n.id === prazoModal.id ? { ...n, lida: 1, prazo_confirmado: 1 } : n));
      setPrazoModal(null);
      setNotification({ type: 'success', message: `Prazo criado! Limite: ${dataLimiteFormatada}`, visible: true });
      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
      loadData(); // recarrega tarefas/agenda
    } catch(e) {
      console.error(e);
    } finally {
      setPrazoSalvando(false);
    }
  };

  const globalSearchResults = useMemo(() => {
    if (!searchTerm.trim()) return null;
    const term = searchTerm.toLowerCase();
    
    const matchedClientes = clientes.filter(c => 
      c.nome.toLowerCase().includes(term) || 
      (c.email && c.email.toLowerCase().includes(term))
    );

    const matchedProcessos = processos.filter(p => 
      (p.numero && p.numero.toLowerCase().includes(term)) ||
      (p.natureza && p.natureza.toLowerCase().includes(term)) ||
      (p.cliente && p.cliente.toLowerCase().includes(term))
    );

    const clientsMap = new Map();
    
    matchedClientes.forEach(c => {
      clientsMap.set(c.nome, { 
        cliente: c, 
        processos: processos.filter(p => p.cliente === c.nome) 
      });
    });

    matchedProcessos.forEach(p => {
      if (!clientsMap.has(p.cliente)) {
        const c = clientes.find(c => c.nome === p.cliente) || { nome: p.cliente, email: '', tipo: 'PF' };
        clientsMap.set(p.cliente, { cliente: c, processos: [] });
      }
      const entry = clientsMap.get(p.cliente);
      if (!entry.processos.find(existingP => existingP.id === p.id)) {
        entry.processos.push(p);
      }
    });

    return Array.from(clientsMap.values());
  }, [clientes, processos, searchTerm]);

  const resetModal = () => {
    setNewClienteNome('');
    setNewClienteTipo('PF');
    setNewClienteEmail('');
    setNewClienteTel('');
    setNewClienteCidade('');
    setIsModalOpen(false);
  };

  const resetProcessoModal = () => {
    setNewProcessoNumero('');
    setNewProcessoCliente('');
    setNewProcessoTipo('');
    setNewProcessoNatureza('');
    setNewProcessoData('');
    setNewProcessoStatus('Ativo');
    setNewProcessoValor('');
    setNewProcessoOrigem('Interno');
    setNewProcessoNumeroJudicial('');
    setIsProcessoModalOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('lex-user');
    setIsAuthenticated(false);
    setUser(null);
  };

  const handleSaveCliente = async () => {
    try {
      const response = await fetch(`${apiBaseUrl}/api/clientes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: newClienteNome,
          tipo: newClienteTipo,
          email: newClienteEmail,
          telefone: newClienteTel,
          cidade: newClienteCidade,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Erro ao salvar cliente.');
      }
      const created = await response.json();

      // Atualiza estado local imediatamente para refletir o novo cliente
      setClientes(prev => [created, ...prev]);

      setNotification({type: 'success', message: `Cliente ${newClienteNome} salvo com sucesso!`, visible: true});
      resetModal();
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    } catch (error) {
      console.error(error);
      setNotification({type: 'error', message: error.message || 'Erro ao salvar cliente.', visible: true});
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    }
  };

  const toggleMonitorar = async (processo) => {
    const novoValor = processo.monitorar ? 0 : 1;
    try {
      await fetch(`${apiBaseUrl}/api/processos/${processo.id}/monitorar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ativo: novoValor === 1 }),
      });
      setProcessos(prev => prev.map(p => p.id === processo.id ? { ...p, monitorar: novoValor } : p));
    } catch (e) { console.error(e); }
  };

  const handleSaveProcesso = async () => {
    try {
      if (!newProcessoCliente) {
        throw new Error('Selecione um cliente');
      }
      if (!newProcessoTipo) {
        throw new Error('Selecione um tipo de processo');
      }
      if (!newProcessoNatureza) {
        throw new Error('Selecione a natureza do processo');
      }
      if (!newProcessoData) {
        throw new Error('Selecione a data do processo');
      }
      if (!newProcessoOrigem) {
        throw new Error('Selecione a origem do processo');
      }
      if (!newProcessoNumeroJudicial) {
        throw new Error('Informe o número do processo');
      }

      const numeroFinal = newProcessoNumeroJudicial;

      const response = await fetch(`${apiBaseUrl}/api/processos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          numero: numeroFinal,
          cliente: newProcessoCliente,
          tipo: newProcessoTipo,
          natureza: newProcessoNatureza,
          status: newProcessoStatus,
          data: newProcessoData,
          valor: parseInt(newProcessoValor) || 0,
          origem: newProcessoOrigem,
          numero_judicial: newProcessoOrigem === 'Judiciário' ? newProcessoNumeroJudicial : '',
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Erro ao salvar processo.');
      }

      await loadData();
      
      if (googleSignedIn && calendarIntegrated && newProcessoData) {
        try {
          await fetch(`${apiBaseUrl}/api/google/sync-event`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              title: `${newProcessoTipo} - ${newProcessoCliente}`,
              processo: numeroFinal,
              cliente: newProcessoCliente,
              natureza: newProcessoNatureza,
              status: newProcessoStatus,
              data: newProcessoData,
            }),
          });
        } catch (calendarError) {
          console.warn('Aviso: Não foi possível sincronizar com Google Calendar');
        }
      }
      
      setNotification({type: 'success', message: `Processo ${numeroFinal} cadastrado com sucesso!`, visible: true});
      resetProcessoModal();
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    } catch (error) {
      console.error(error);
      setNotification({type: 'error', message: error.message || 'Erro ao salvar processo.', visible: true});
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    }
  };

  const handleGoogleAuth = async () => {
    try {
      if (googleSignedIn && calendarIntegrated) {
        setGoogleSignedIn(false);
        setCalendarIntegrated(false);
        setNotification({type: 'success', message: 'Desconectado do Google Calendar', visible: true});
      } else {
        const authUrl = `${apiBaseUrl}/auth/google`;
        window.location.href = authUrl;
      }
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    } catch (error) {
      console.error('Erro ao autenticar com Google:', error);
      setNotification({type: 'error', message: 'Erro ao autenticar com Google', visible: true});
      setTimeout(() => setNotification({...notification, visible: false}), 3000);
    }
  };

  const clientesEnriquecidos = useMemo(() => {
    return clientes.map(c => {
      const procs = processos.filter(p => p.cliente_id === c.id || p.cliente === c.nome);
      return {
        ...c,
        processosAtivos: procs.filter(p => p.status === 'Ativo').length,
        totalGasto: procs.reduce((sum, p) => sum + Number(p.valor || 0), 0),
      };
    });
  }, [clientes, processos]);

  const filteredClientes = useMemo(() => {
    return clientesEnriquecidos.filter(c => {
      const email = (c.email || '').toString();
      const matchesSearch = c.nome.toLowerCase().includes(searchTerm.toLowerCase()) || email.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesType = filterType === 'Todos' || c.tipo === filterType;
      return matchesSearch && matchesType;
    });
  }, [clientesEnriquecidos, searchTerm, filterType]);

  const parseProcessDate = (dateString) => {
    if (!dateString) return null;
    const direct = new Date(dateString);
    if (!Number.isNaN(direct.getTime())) return direct;

    // eslint-disable-next-line no-useless-escape
    const parts = dateString.split(/[\/.-]/);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const isoDate = `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      const parsed = new Date(isoDate);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
  };

  const formatDeadlineDate = (date) => {
    if (!date) return '-';
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
  };

  const reportTipos = useMemo(() => {
    return [...new Set(processos.map((p) => p.tipo).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [processos]);

  const reportClientes = useMemo(() => {
    return [...new Set(processos.map((p) => p.cliente).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [processos]);

  const filteredReportProcessos = useMemo(() => {
    const from = reportDateFrom ? new Date(`${reportDateFrom}T00:00:00`) : null;
    const to = reportDateTo ? new Date(`${reportDateTo}T23:59:59`) : null;

    return processos.filter((p) => {
      const processDate = parseProcessDate(p.data);

      if (from && (!processDate || processDate < from)) return false;
      if (to && (!processDate || processDate > to)) return false;
      if (reportStatus !== 'Todos' && p.status !== reportStatus) return false;
      if (reportTipo !== 'Todos' && p.tipo !== reportTipo) return false;
      if (reportCliente !== 'Todos' && p.cliente !== reportCliente) return false;

      return true;
    });
  }, [processos, reportDateFrom, reportDateTo, reportStatus, reportTipo, reportCliente]);

  const reportMetricas = useMemo(() => {
    const total = filteredReportProcessos.length;
    const ativos = filteredReportProcessos.filter((p) => p.status === 'Ativo').length;
    const concluidos = filteredReportProcessos.filter((p) => p.status === 'Concluído').length;
    const valorTotal = filteredReportProcessos.reduce((acc, curr) => acc + (curr.valor || 0), 0);
    const mediaValor = total ? valorTotal / total : 0;
    const taxaSucesso = total ? (concluidos / total) * 100 : 0;
    const naturezaDist = filteredReportProcessos.reduce((acc, curr) => {
      acc[curr.natureza] = (acc[curr.natureza] || 0) + 1;
      return acc;
    }, {});

    return { total, ativos, concluidos, valorTotal, mediaValor, taxaSucesso, naturezaDist };
  }, [filteredReportProcessos]);

  const metricas = useMemo(() => {
    const total = processos.length;
    const ativos = processos.filter(p => p.status === 'Ativo').length;
    const valorTotal = processos.reduce((acc, curr) => acc + curr.valor, 0);
    const mediaValor = total ? valorTotal / total : 0;
    const naturezaDist = processos.reduce((acc, curr) => {
      acc[curr.natureza] = (acc[curr.natureza] || 0) + 1;
      return acc;
    }, {});

    return { total, ativos, valorTotal, mediaValor, naturezaDist };
  }, [processos]);

  const processosProximosPrazos = useMemo(() => {
    const agora = new Date();

    return processos
      .map((p) => {
        // Prioridade: prazo_data_limite (prazo processual confirmado) → data (data do processo)
        const due = parseProcessDate(p.prazo_data_limite) || parseProcessDate(p.data);
        if (!due) return null;
        const diffDays = Math.ceil((due - agora) / (1000 * 60 * 60 * 24));
        const isPrazoConfirmado = !!p.prazo_data_limite;
        return { ...p, due, daysLeft: diffDays, isPrazoConfirmado };
      })
      .filter((p) => p && p.daysLeft >= 0 && p.daysLeft <= 7)
      .sort((a, b) => a.due - b.due);
  }, [processos]);

  const growthData = useMemo(() => {
    const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
    const agrupado = {};
    processos.forEach(p => {
      const d = p.created_at ? new Date(p.created_at) : null;
      if (!d || isNaN(d)) return;
      const key = `${d.getFullYear()}-${String(d.getMonth()).padStart(2,'0')}`;
      if (!agrupado[key]) agrupado[key] = { key, mes: MESES[d.getMonth()], receita: 0, processos: 0 };
      agrupado[key].processos += 1;
      agrupado[key].receita += Number(p.valor || 0);
    });
    const resultado = Object.values(agrupado).sort((a,b) => a.key.localeCompare(b.key)).slice(-12);
    if (resultado.length === 0) {
      return MESES.map(mes => ({ mes, receita: 0, processos: 0 })).slice(0, 6);
    }
    return resultado;
  }, [processos]);

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.text('Relatorio Analitico - LexControl', 20, 30);

    doc.setFontSize(12);
    doc.text(`Data de geracao: ${new Date().toLocaleDateString('pt-BR')}`, 20, 50);
    doc.text(`Processos filtrados: ${reportMetricas.total}`, 20, 60);

    doc.text('Metricas Principais:', 20, 80);
    doc.text(`Ticket Medio: R$ ${reportMetricas.mediaValor.toLocaleString('pt-BR')}`, 20, 95);
    doc.text(`Taxa de Sucesso: ${reportMetricas.taxaSucesso.toFixed(1)}%`, 20, 105);

    doc.text('Distribuicao por Natureza:', 20, 125);
    let y = 140;
    Object.entries(reportMetricas.naturezaDist).forEach(([natureza, count]) => {
      const percentage = reportMetricas.total ? (count / reportMetricas.total) * 100 : 0;
      doc.text(`${natureza}: ${Math.round(percentage)}% (${count} processos)`, 20, y);
      y += 10;
    });

    doc.save('relatorio-lexcontrol.pdf');
    setIsExportDropdownOpen(false);
  };

  const exportToExcel = () => {
    const data = [
      ['Metrica', 'Valor'],
      ['Processos filtrados', reportMetricas.total],
      ['Ticket Medio', `R$ ${reportMetricas.mediaValor.toLocaleString('pt-BR')}`],
      ['Taxa de Sucesso', `${reportMetricas.taxaSucesso.toFixed(1)}%`],
      ['', ''],
      ['Natureza', 'Quantidade', 'Percentual']
    ];

    Object.entries(reportMetricas.naturezaDist).forEach(([natureza, count]) => {
      const percentage = reportMetricas.total ? (count / reportMetricas.total) * 100 : 0;
      data.push([natureza, count, `${Math.round(percentage)}%`]);
    });

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Relatorio');
    XLSX.writeFile(wb, 'relatorio-lexcontrol.xlsx');
    setIsExportDropdownOpen(false);
  };

  if (!isAuthenticated) {
    return <LoginModule onLogin={(userData) => {
      localStorage.setItem('lex-user', JSON.stringify(userData));
      setUser(userData);
      setIsAuthenticated(true);
    }} />;
  }

  return (
    <div className={`flex h-screen font-sans text-slate-900${darkMode ? ' dark-mode bg-[#0d1117]' : ' bg-[#F8FAFC]'}`}>
      {/* Sidebar */}
      <aside className={`w-64 border-r flex flex-col shadow-sm ${darkMode ? 'bg-[#111827] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
        <div className="p-8 flex items-center gap-3">
          <div className="bg-blue-600 p-2 rounded-lg">
            <Scale size={24} className="text-white" />
          </div>
          <span className="font-black text-xl tracking-tight text-slate-800">LexControl</span>
        </div>

        <nav className="flex-1 px-4 space-y-1">
          <NavItem icon={<LayoutDashboard size={18} />} label="Dashboard" active={activeTab === 'dash'} onClick={() => setActiveTab('dash')} />
          <NavItem icon={<Briefcase size={18} />} label="Processos" active={activeTab === 'processos'} onClick={() => setActiveTab('processos')} />
          <NavItem icon={<Users size={18} />} label="Clientes" active={activeTab === 'clientes'} onClick={() => setActiveTab('clientes')} />
          <NavItem icon={<DollarSign size={18} />} label="Financeiro" active={activeTab === 'financas'} onClick={() => setActiveTab('financas')} />
          <NavItem icon={<FileText size={18} />} label="Relatórios" active={activeTab === 'reports'} onClick={() => setActiveTab('reports')} />
          <NavItem icon={<Globe size={18} />} label="Consulta CNJ" active={activeTab === 'consulta'} onClick={() => setActiveTab('consulta')} />
          <NavItem icon={<Bot size={18} />} label="Legal AI" active={activeTab === 'ia'} onClick={() => setActiveTab('ia')} />
          <NavItem icon={<FileSignature size={18} />} label="Documentos" active={activeTab === 'docs'} onClick={() => setActiveTab('docs')} />
          <NavItem icon={<ClipboardCheck size={18} />} label="Homologações" active={activeTab === 'homologacoes'} onClick={() => setActiveTab('homologacoes')} />
          <NavItem icon={<Calculator size={18} />} label="Diferença Salarial" active={activeTab === 'diferenca-salarial'} onClick={() => setActiveTab('diferenca-salarial')} />
        </nav>

        <div className="p-4 mt-auto border-t border-slate-100 space-y-2">
          <NavItem icon={<Settings size={18} />} label="Configurações" active={activeTab === 'settings'} onClick={() => setActiveTab('settings')} />
          <button 
            onClick={handleLogout}
            className="flex items-center gap-3 w-full p-3 rounded-xl text-slate-500 hover:text-red-600 hover:bg-red-50 transition-all font-medium text-sm group"
          >
            <LogOut size={18} className="group-hover:text-red-500 transition-colors" />
            Sair do Sistema
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`flex-1 overflow-auto flex flex-col ${darkMode ? 'bg-[#0d1117]' : ''}`}>
        {/* Header */}
        <header className={`h-20 border-b flex items-center justify-between px-10 shrink-0 relative z-50 ${darkMode ? 'bg-[#111827] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
          <div className="relative w-full max-w-lg" ref={searchRef}>
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
            <input 
              type="text" 
              placeholder="Pesquisar clientes ou processos..."
              className="w-full pl-10 pr-4 py-2.5 bg-slate-100 border-none rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20 transition-all"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={() => setIsSearchFocused(true)}
            />
            {isSearchFocused && globalSearchResults && globalSearchResults.length > 0 && (
              <div className="absolute top-full left-0 mt-2 w-full max-h-[60vh] overflow-y-auto bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-2 z-50">
                <div className="px-3 py-2 text-[10px] font-black uppercase text-slate-400 tracking-wider">
                  Resultados da Pesquisa
                </div>
                {globalSearchResults.map((result, idx) => (
                  <div key={idx} className="mb-2 last:mb-0 border border-slate-100 rounded-xl overflow-hidden hover:border-blue-200 transition-colors">
                    {/* Cliente Cabeçalho */}
                    <div className="bg-slate-50 px-4 py-3 flex items-center justify-between cursor-pointer hover:bg-blue-50/50 transition-colors" onClick={() => { setActiveTab('clientes'); setSearchTerm(result.cliente.nome); setIsSearchFocused(false); }}>
                      <div className="flex items-center gap-3">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${result.cliente.tipo === 'PF' ? 'bg-blue-100 text-blue-600' : 'bg-indigo-100 text-indigo-600'}`}>
                          {result.cliente.tipo === 'PF' ? <UserCheck size={16} /> : <Building2 size={16} />}
                        </div>
                        <div>
                          <h4 className="font-bold text-slate-800 text-sm leading-tight">{result.cliente.nome}</h4>
                          {result.cliente.email && <span className="text-xs text-slate-500">{result.cliente.email}</span>}
                        </div>
                      </div>
                      <span className="text-[10px] font-black uppercase px-2 py-0.5 rounded-md bg-white text-slate-500 border border-slate-200">
                        {result.processos.length} Processos
                      </span>
                    </div>
                    {/* Lista de Processos do Cliente */}
                    {result.processos.length > 0 && (
                      <div className="px-4 py-2 bg-white divide-y divide-slate-50">
                        {result.processos.map((proc, pIdx) => (
                          <div key={pIdx} className="py-2.5 flex justify-between items-center group cursor-pointer hover:bg-slate-50 rounded-lg px-2 -mx-2 transition-colors" onClick={() => { setActiveTab('processos'); setSearchTerm(proc.processo); setIsSearchFocused(false); }}>
                            <div className="flex flex-col">
                              <span className="text-sm font-semibold text-slate-700 group-hover:text-blue-600 transition-colors">{proc.processo}</span>
                              <span className="text-xs text-slate-400">{proc.natureza} • {proc.status}</span>
                            </div>
                            <span className="text-sm font-bold text-slate-800">R$ {(proc.valor || 0).toLocaleString('pt-BR')}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
            {isSearchFocused && globalSearchResults && globalSearchResults.length === 0 && (
              <div className="absolute top-full left-0 mt-2 w-full bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-8 z-50 text-center">
                 <Search size={32} className="mx-auto text-slate-300 mb-3" />
                 <p className="text-sm font-bold text-slate-600">Nenhum resultado encontrado</p>
                 <p className="text-xs text-slate-400 mt-1">Tente pesquisar por outro termo.</p>
              </div>
            )}
          </div>
          
          <div className="flex items-center gap-4">
            {/* Sino de Notificações */}
            <div className="relative" ref={notifRef}>
              <button
                onClick={() => setIsNotifDropdownOpen(v => !v)}
                className="p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors relative"
              >
                <Bell size={20} />
                {notificacoes.filter(n => !n.lida).length > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1 border-2 border-white">
                    {notificacoes.filter(n => !n.lida).length > 9 ? '9+' : notificacoes.filter(n => !n.lida).length}
                  </span>
                )}
              </button>

              {isNotifDropdownOpen && (
                <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-2xl shadow-xl border border-slate-100 z-50 overflow-hidden">
                  <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
                    <span className="font-bold text-slate-800 text-sm">Notificações</span>
                    {notificacoes.some(n => !n.lida) && (
                      <button onClick={marcarTodasLidas} className="text-xs text-blue-600 hover:underline font-medium">
                        Marcar todas como lidas
                      </button>
                    )}
                  </div>
                  <div className="max-h-80 overflow-y-auto divide-y divide-slate-50">
                    {notificacoes.length === 0 ? (
                      <div className="px-4 py-8 text-center">
                        <Bell size={28} className="mx-auto text-slate-300 mb-2" />
                        <p className="text-sm text-slate-500">Nenhuma notificação</p>
                      </div>
                    ) : (
                      notificacoes.slice(0, 20).map(n => (
                        <div
                          key={n.id}
                          onClick={() => abrirModalPrazo(n)}
                          className={`px-4 py-3 cursor-pointer hover:bg-slate-50 transition-colors ${!n.lida ? 'bg-blue-50/40' : ''}`}
                        >
                          <div className="flex items-start gap-2">
                            {!n.lida && <span className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 shrink-0"></span>}
                            {n.lida && <span className="w-2 h-2 rounded-full bg-transparent mt-1.5 shrink-0"></span>}
                            <div className="flex-1 min-w-0">
                              <p className={`text-sm leading-snug ${!n.lida ? 'font-semibold text-slate-800' : 'text-slate-600'}`}>{n.titulo}</p>
                              <p className="text-xs text-slate-400 mt-0.5 truncate">{n.descricao}</p>
                              <p className="text-[10px] text-slate-400 mt-1">{n.cliente} • {new Date(n.created_at).toLocaleDateString('pt-BR')}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {notificacoes.length > 0 && (
                    <div className="px-4 py-2 border-t border-slate-100 text-center">
                      <button
                        onClick={() => { setActiveTab('processos'); setIsNotifDropdownOpen(false); }}
                        className="text-xs text-blue-600 hover:underline font-medium"
                      >
                        Ver processos monitorados
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="h-8 w-px bg-slate-200 mx-2"></div>
            <button
              onClick={() => {
                const next = !darkMode;
                setDarkMode(next);
                localStorage.setItem('lex-dark', next ? '1' : '0');
              }}
              title={darkMode ? 'Modo claro' : 'Modo escuro'}
              className="p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors"
            >
              {darkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl text-sm font-bold shadow-lg shadow-blue-200 transition-all active:scale-95"
            >
              <Plus size={18} /> Novo Cliente
            </button>
          </div>
        </header>

        {/* Content Area */}
        <div className={`p-10 max-w-7xl mx-auto w-full space-y-8 ${darkMode ? 'text-slate-100' : ''}`}>
          
          {/* DASHBOARD TAB */}
          {activeTab === 'dash' && (
            <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <StatCard title="Processos Ativos" value={metricas.ativos} trend={`${metricas.total} total`} positive={true} icon={<Briefcase className="text-blue-600" />} color="bg-blue-50" />
                <StatCard title="Prazos Próximos" value={processosProximosPrazos.length} trend={processosProximosPrazos.length > 0 ? `${processosProximosPrazos[0]?.daysLeft ?? 0}d` : 'Nenhum'} positive={processosProximosPrazos.length === 0} icon={<Clock className="text-amber-600" />} color="bg-amber-50" />
                <StatCard title="Clientes" value={clientes.length} trend={`${processos.filter(p => p.status === 'Ativo').length} processos ativos`} positive={true} icon={<Users className="text-emerald-600" />} color="bg-emerald-50" />
                <StatCard title="Valor em Gestão" value={`R$ ${metricas.valorTotal.toLocaleString('pt-BR')}`} trend={metricas.total > 0 ? `R$ ${metricas.mediaValor.toLocaleString('pt-BR', {maximumFractionDigits:0})} médio` : '-'} positive={true} icon={<DollarSign className="text-indigo-600" />} color="bg-indigo-50" />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
                  <h3 className="font-bold text-slate-800 mb-6 flex items-center gap-2">
                    <TrendingUp size={18} className="text-blue-600" /> Crescimento Exponencial
                  </h3>
                  <ExponentialChart data={growthData} />
                </div>

                <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
                  <h3 className="font-bold text-slate-800 mb-6 flex items-center gap-2">
                    <Clock size={18} className="text-blue-600" /> Próximos Prazos
                  </h3>
                  <div className="space-y-4">
                    {processosProximosPrazos.length > 0 ? (
                      processosProximosPrazos.slice(0, 3).map((p) => {
                        const urgency = p.daysLeft <= 1 ? 'high' : p.daysLeft <= 3 ? 'medium' : 'low';
                        const dateLabel = p.daysLeft === 0 ? 'Hoje' : p.daysLeft === 1 ? 'Amanhã' : `${p.daysLeft} dias`;
                        const tipoLabel = p.isPrazoConfirmado && p.prazo_tipo ? p.prazo_tipo : null;
                        return (
                          <DeadlineItem
                            key={p.id}
                            title={tipoLabel ? `${tipoLabel} — ${p.cliente}` : `${p.numero} - ${p.cliente}`}
                            date={`${formatDeadlineDate(p.due)} · ${dateLabel}${p.isPrazoConfirmado ? ' · prazo confirmado' : ''}`}
                            urgency={urgency}
                          />
                        );
                      })
                    ) : (
                      <div className="px-4 py-6 rounded-xl bg-slate-50 text-sm text-slate-500">Nenhum processo com prazo nos próximos 7 dias.</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Desempenho Mensal — dados reais de growthData */}
              {(() => {
                const ultimos6 = growthData.slice(-6);
                const atual = ultimos6[ultimos6.length - 1] || { mes: '—', processos: 0, receita: 0 };
                const anterior = ultimos6[ultimos6.length - 2] || null;
                const diffProc = anterior ? atual.processos - anterior.processos : 0;
                const pctProc = anterior && anterior.processos > 0
                  ? ((diffProc / anterior.processos) * 100).toFixed(1)
                  : null;
                const maxProc = Math.max(...ultimos6.map(d => d.processos), 1);
                const barW = 32;
                const barGap = 8;
                const chartH = 72;
                const totalW = ultimos6.length * (barW + barGap) - barGap;
                return (
                  <div className={`p-8 rounded-2xl border shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
                      {/* Métricas */}
                      <div className="min-w-[200px]">
                        <h3 className={`font-bold mb-4 flex items-center gap-2 ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>
                          <BarChart3 size={18} className="text-blue-600" /> Desempenho Mensal
                        </h3>
                        <div className="flex items-end gap-3 mb-2">
                          <span className={`text-4xl font-black ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>{atual.processos}</span>
                          <span className={`text-sm font-medium mb-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>processos em {atual.mes}</span>
                        </div>
                        {pctProc !== null ? (
                          <span className={`inline-flex items-center gap-1 text-xs font-black px-2.5 py-1 rounded-full ${
                            diffProc >= 0
                              ? 'bg-emerald-50 text-emerald-700 border border-emerald-100'
                              : 'bg-red-50 text-red-700 border border-red-100'
                          }`}>
                            {diffProc >= 0 ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
                            {Math.abs(pctProc)}% vs {anterior.mes}
                          </span>
                        ) : (
                          <span className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Sem dados comparativos</span>
                        )}
                        <div className={`mt-4 pt-4 border-t ${darkMode ? 'border-[#1e293b]' : 'border-slate-100'}`}>
                          <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                            Valor em processos ({atual.mes})
                          </p>
                          <p className={`text-base font-black mt-0.5 ${darkMode ? 'text-slate-200' : 'text-slate-700'}`}>
                            {atual.receita > 0 ? `R$ ${atual.receita.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : 'Sem valor registrado'}
                          </p>
                        </div>
                      </div>

                      {/* Mini bar chart */}
                      <div className="flex-1 flex flex-col items-end">
                        <svg width={totalW} height={chartH + 20} viewBox={`0 0 ${totalW} ${chartH + 20}`} className="overflow-visible">
                          {ultimos6.map((d, i) => {
                            const barH = maxProc > 0 ? Math.max((d.processos / maxProc) * chartH, 4) : 4;
                            const x = i * (barW + barGap);
                            const y = chartH - barH;
                            const isLast = i === ultimos6.length - 1;
                            return (
                              <g key={d.mes || i}>
                                <rect
                                  x={x} y={y} width={barW} height={barH}
                                  rx="6"
                                  fill={isLast ? '#2563eb' : (darkMode ? '#1e293b' : '#e2e8f0')}
                                />
                                {isLast && d.processos > 0 && (
                                  <text x={x + barW / 2} y={y - 6} textAnchor="middle" fontSize="11" fontWeight="800" fill="#2563eb">
                                    {d.processos}
                                  </text>
                                )}
                                <text x={x + barW / 2} y={chartH + 16} textAnchor="middle" fontSize="10" fill={darkMode ? '#475569' : '#94a3b8'}>
                                  {d.mes}
                                </text>
                              </g>
                            );
                          })}
                        </svg>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Calendar Integration */}
              <div>
                <Calendar processos={processos} />
              </div>

              {/* Google Calendar Integration Status */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-2xl border border-blue-200 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <LogIn size={24} className="text-blue-600" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-800">Google Calendar</h3>
                      <p className={`text-sm ${googleSignedIn ? 'text-emerald-600 font-semibold' : 'text-slate-600'}`}>
                        {googleSignedIn && calendarIntegrated ? '✓ Conectado e sincronizando' : 'Conecte para sincronizar processos automaticamente'}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleGoogleAuth()}
                    className={`px-6 py-2.5 rounded-xl font-bold text-sm transition-all ${
                      googleSignedIn && calendarIntegrated
                        ? 'bg-red-500 hover:bg-red-600 text-white'
                        : 'bg-blue-600 hover:bg-blue-700 text-white'
                    }`}
                  >
                    {googleSignedIn && calendarIntegrated ? 'Desconectar' : 'Conectar Google'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* FINANCEIRO TAB */}
          {activeTab === 'financas' && (
            <FinanceiroModule apiBaseUrl={apiBaseUrl} processos={processos} darkMode={darkMode} />
          )}

          {/* HOMOLOGAÇÕES TAB */}
          {activeTab === 'homologacoes' && (
            <HomologacaoModule darkMode={darkMode} />
          )}

          {/* DIFERENÇA SALARIAL TAB */}
          {activeTab === 'diferenca-salarial' && (
            <DiferencaSalarialModule darkMode={darkMode} />
          )}

          {/* CLIENTES TAB (CORRIGIDO) */}
          {activeTab === 'clientes' && (
            <div className="space-y-6 animate-in fade-in duration-500">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-black text-slate-800 tracking-tight">Gestão de Clientes</h2>
                  <p className="text-slate-500 text-sm font-medium">Controle e histórico de relacionamento.</p>
                </div>
                <div className="flex bg-white p-1 rounded-xl border border-slate-200 shadow-sm">
                  <button 
                    onClick={() => setFilterType('Todos')}
                    className={`px-4 py-1.5 rounded-lg text-xs font-bold transition-all ${filterType === 'Todos' ? 'bg-blue-600 text-white shadow-md shadow-blue-100' : 'text-slate-500 hover:text-slate-800'}`}
                  >
                    Todos
                  </button>
                  <button 
                    onClick={() => setFilterType('PF')}
                    className={`px-4 py-1.5 rounded-lg text-xs font-bold transition-all ${filterType === 'PF' ? 'bg-blue-600 text-white shadow-md shadow-blue-100' : 'text-slate-500 hover:text-slate-800'}`}
                  >
                    PF
                  </button>
                  <button 
                    onClick={() => setFilterType('PJ')}
                    className={`px-4 py-1.5 rounded-lg text-xs font-bold transition-all ${filterType === 'PJ' ? 'bg-blue-600 text-white shadow-md shadow-blue-100' : 'text-slate-500 hover:text-slate-800'}`}
                  >
                    PJ
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {filteredClientes.map(cliente => (
                  <div key={cliente.id} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-all group relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button className="text-slate-400 hover:text-slate-600"><MoreVertical size={18} /></button>
                    </div>
                    
                    <div className="flex items-start gap-4 mb-6">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${cliente.tipo === 'PF' ? 'bg-blue-50 text-blue-600' : 'bg-indigo-50 text-indigo-600'}`}>
                        {cliente.tipo === 'PF' ? <UserCheck size={24} /> : <Building2 size={24} />}
                      </div>
                      <div className="overflow-hidden">
                        <h4 className="font-black text-slate-800 truncate leading-tight mb-1">{cliente.nome}</h4>
                        <span className={`text-[10px] font-black uppercase px-2 py-0.5 rounded-md ${cliente.tipo === 'PF' ? 'bg-blue-100 text-blue-700' : 'bg-indigo-100 text-indigo-700'}`}>
                          {cliente.tipo === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                        </span>
                      </div>
                    </div>

                    <div className="space-y-3 mb-6">
                      <div className="flex items-center gap-3 text-slate-500">
                        <Mail size={14} className="shrink-0" />
                        <span className="text-xs font-medium truncate">{cliente.email}</span>
                      </div>
                      <div className="flex items-center gap-3 text-slate-500">
                        <Phone size={14} className="shrink-0" />
                        <span className="text-xs font-medium">{cliente.tel}</span>
                      </div>
                      <div className="flex items-center gap-3 text-slate-500">
                        <MapPin size={14} className="shrink-0" />
                        <span className="text-xs font-medium">{cliente.cidade}</span>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3 pt-4 border-t border-slate-100">
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-slate-400 uppercase">Processos</span>
                        <span className="text-sm font-black text-slate-800">{cliente.processosAtivos} Ativos</span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-slate-400 uppercase">Faturamento</span>
                        <span className="text-sm font-black text-emerald-600">R$ {cliente.totalGasto.toLocaleString()}</span>
                      </div>
                    </div>

                    <button
                      onClick={() => setDossierCliente(cliente)}
                      className="w-full mt-6 flex items-center justify-center gap-2 py-2.5 bg-slate-50 hover:bg-blue-600 hover:text-white rounded-xl text-xs font-bold text-slate-600 transition-all border border-slate-100">
                      Visualizar Dossier <ExternalLink size={14} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* PROCESSOS TAB */}
          {activeTab === 'processos' && (
            <div className="space-y-6 animate-in fade-in duration-500">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-black text-slate-800 tracking-tight">Processos Judiciais</h2>
                  <p className="text-slate-500 text-sm font-medium">Cadastro e acompanhamento de processos.</p>
                </div>
                <button 
                  onClick={() => setIsProcessoModalOpen(true)}
                  className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold shadow-md hover:shadow-lg transition-all"
                >
                  <Plus size={18} /> Novo Processo
                </button>
              </div>

              <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                <table className="w-full text-left border-collapse">
                <thead className="bg-slate-50 text-slate-500 text-xs font-bold uppercase tracking-wider">
                  <tr>
                    <th className="px-6 py-4">Nº Processo</th>
                    <th className="px-6 py-4">Cliente</th>
                    <th className="px-6 py-4">Natureza</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4">Prazo</th>
                    <th className="px-6 py-4 text-right">Valor</th>
                    <th className="px-6 py-4 text-center">Monitor</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {processos.map((p) => {
                    const dueDate = parseProcessDate(p.data);
                    const deadlineLabel = dueDate ? formatDeadlineDate(dueDate) : '-';
                    return (
                      <tr key={p.id} className="hover:bg-slate-50 transition-colors">
                        <td className="px-6 py-4">
                          <div className="flex flex-col gap-1">
                            <span className="text-sm font-medium text-slate-600">{p.numero}</span>
                            {p.origem !== 'Datajud' && (
                              <span className="inline-flex items-center gap-1 text-[10px] font-bold text-amber-600 bg-amber-50 border border-amber-100 px-2 py-0.5 rounded-full w-fit">
                                ⚠ Atualização manual
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                           <div className="flex flex-col">
                              <span className="text-sm font-bold text-slate-800">{p.cliente}</span>
                              <span className="text-[10px] text-slate-400 font-bold uppercase">{p.tipo}</span>
                           </div>
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-600">{p.natureza}</td>
                        <td className="px-6 py-4">
                          <span className={`px-3 py-1 rounded-full text-[11px] font-bold ${
                            p.status === 'Ativo' ? 'bg-emerald-50 text-emerald-600 border border-emerald-100' : 
                            p.status === 'Pendente' ? 'bg-amber-50 text-amber-600 border border-amber-100' : 
                            'bg-slate-100 text-slate-600 border border-slate-200'
                          }`}>
                            {p.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-600">{deadlineLabel}</td>
                        <td className="px-6 py-4 text-sm font-bold text-slate-800 text-right">R$ {p.valor.toLocaleString()}</td>
                        <td className="px-6 py-4 text-center">
                          <button
                            onClick={() => toggleMonitorar(p)}
                            title={p.monitorar ? 'Parar monitoramento' : 'Monitorar processo'}
                            className={`p-1.5 rounded-lg transition-all ${p.monitorar ? 'bg-blue-100 text-blue-600 hover:bg-blue-200' : 'bg-slate-100 text-slate-400 hover:bg-slate-200'}`}
                          >
                            <Bell size={14} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            </div>
          )}

          {/* CONSULTA CNJ TAB */}
          {activeTab === 'consulta' && (
            <ConsultaProcessual apiBaseUrl={apiBaseUrl} />
          )}

          {/* LEGAL AI TAB */}
          {activeTab === 'ia' && (
            <LegalAIModule apiBaseUrl={apiBaseUrl} />
          )}

          {/* DOCUMENTOS TAB */}
          {activeTab === 'docs' && (
            <div className="space-y-6 animate-in fade-in duration-500">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-black text-slate-800 tracking-tight">Documentos & Assinaturas</h2>
                  <p className="text-slate-500 text-sm font-medium">Crie documentos e colete assinaturas eletrônicas com validade jurídica.</p>
                </div>
                <button
                  onClick={() => setDocModal(true)}
                  className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold shadow-md transition-all"
                >
                  <Plus size={18} /> Novo Documento
                </button>
              </div>

              {/* Info strip */}
              <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 flex items-start gap-3">
                <AlertCircle size={18} className="text-blue-600 shrink-0 mt-0.5" />
                <p className="text-sm text-blue-700">Assinatura eletrônica simples com validade jurídica (MP 2.200-2/2001). O signatário recebe um email com link e código OTP para confirmar. IP e horário são registrados.</p>
              </div>

              {/* Documentos list */}
              <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                {documentos.length === 0 ? (
                  <div className="text-center py-16">
                    <FileSignature size={40} className="mx-auto text-slate-300 mb-3" />
                    <p className="font-bold text-slate-600">Nenhum documento criado</p>
                    <p className="text-sm text-slate-400 mt-1">Crie contratos, procurações e outros documentos para assinar eletronicamente.</p>
                  </div>
                ) : (
                  <table className="w-full text-left border-collapse">
                    <thead className="bg-slate-50 text-slate-500 text-xs font-bold uppercase tracking-wider">
                      <tr>
                        <th className="px-6 py-4">Documento</th>
                        <th className="px-6 py-4">Tipo</th>
                        <th className="px-6 py-4">Cliente</th>
                        <th className="px-6 py-4">Status</th>
                        <th className="px-6 py-4">Assinaturas</th>
                        <th className="px-6 py-4">Data</th>
                        <th className="px-6 py-4 text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {documentos.map(doc => (
                        <tr key={doc.id} className="hover:bg-slate-50 transition-colors">
                          <td className="px-6 py-4">
                            <span className="text-sm font-bold text-slate-800">{doc.titulo}</span>
                          </td>
                          <td className="px-6 py-4">
                            <span className="text-xs text-slate-500">{doc.tipo}</span>
                          </td>
                          <td className="px-6 py-4">
                            <span className="text-sm text-slate-600">{doc.cliente || '-'}</span>
                          </td>
                          <td className="px-6 py-4">
                            <span className={`px-3 py-1 rounded-full text-[11px] font-bold ${
                              doc.status === 'Assinado' ? 'bg-emerald-50 text-emerald-700 border border-emerald-100' :
                              doc.status === 'Aguardando Assinatura' ? 'bg-amber-50 text-amber-700 border border-amber-100' :
                              'bg-slate-100 text-slate-600 border border-slate-200'
                            }`}>{doc.status}</span>
                          </td>
                          <td className="px-6 py-4 text-sm text-slate-600">
                            {doc.assinados || 0}/{doc.total_signatarios || 0}
                          </td>
                          <td className="px-6 py-4 text-xs text-slate-400">
                            {doc.created_at ? new Date(doc.created_at).toLocaleDateString('pt-BR') : '-'}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center justify-center gap-2">
                              {doc.arquivo_base64 && (
                                <button
                                  onClick={() => {
                                    const byteChars = atob(doc.arquivo_base64);
                                    const byteNumbers = new Array(byteChars.length);
                                    for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
                                    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
                                    window.open(URL.createObjectURL(blob), '_blank');
                                  }}
                                  title={doc.status === 'Assinado' ? 'Visualizar documento assinado' : 'Visualizar/baixar PDF'}
                                  className={`p-1.5 rounded-lg transition-all ${doc.status === 'Assinado' ? 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100' : 'bg-slate-50 text-slate-500 hover:bg-slate-100'}`}
                                >
                                  <Download size={14} />
                                </button>
                              )}
                              {doc.arquivo_base64 && (
                                <button
                                  onClick={() => {
                                    setDocEnviarModal(doc);
                                    setDocEnviarEmail('');
                                  }}
                                  title="Enviar por email"
                                  className="p-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-all"
                                >
                                  <Mail size={14} />
                                </button>
                              )}
                              <button
                                onClick={async () => {
                                  setDocSigModal(doc);
                                  setSigNome(doc.cliente || '');
                                  setSigEmail('');
                                  const res = await fetch(`${apiBaseUrl}/api/documentos/${doc.id}/assinaturas`);
                                  if (res.ok) setDocAssinaturas(await res.json());
                                  else setDocAssinaturas([]);
                                }}
                                title="Solicitar assinatura"
                                className="p-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-all"
                              >
                                <Send size={14} />
                              </button>
                              <button
                                onClick={async () => {
                                  if (!window.confirm('Excluir este documento?')) return;
                                  await fetch(`${apiBaseUrl}/api/documentos/${doc.id}`, { method: 'DELETE' });
                                  loadDocumentos();
                                }}
                                title="Excluir"
                                className="p-1.5 bg-slate-50 text-slate-400 rounded-lg hover:bg-red-50 hover:text-red-500 transition-all"
                              >
                                <Trash2 size={14} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

          {/* RELATÓRIOS TAB */}
          {/* SETTINGS TAB */}
          {activeTab === 'settings' && (
            <div className="space-y-8 animate-in fade-in duration-500 max-w-2xl">
              <div>
                <h2 className={`text-2xl font-black tracking-tight ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>Configurações</h2>
                <p className={`text-sm font-medium mt-1 ${darkMode ? 'text-slate-500' : 'text-slate-500'}`}>Preferências do sistema e automações.</p>
              </div>

              {/* Atualização automática */}
              <div className={`rounded-2xl border p-8 shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                    <Clock size={20} className="text-blue-600" />
                  </div>
                  <div>
                    <h3 className={`font-bold ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>Atualização Automática de Processos</h3>
                    <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      O sistema consultará o Datajud uma vez por dia no horário configurado para todos os processos monitorados.
                    </p>
                  </div>
                </div>

                <div className="space-y-5">
                  {/* Toggle ativo */}
                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`text-sm font-bold ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>Atualização automática</p>
                      <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Ativar ou desativar a consulta automática ao Datajud</p>
                    </div>
                    <button
                      onClick={() => setSysConfig(prev => ({ ...prev, update_enabled: prev.update_enabled === '1' ? '0' : '1' }))}
                      className={`relative w-12 h-6 rounded-full transition-colors ${sysConfig.update_enabled === '1' ? 'bg-blue-600' : (darkMode ? 'bg-[#2d3748]' : 'bg-slate-200')}`}
                    >
                      <span className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-all ${sysConfig.update_enabled === '1' ? 'left-7' : 'left-1'}`} />
                    </button>
                  </div>

                  {/* Modo */}
                  <div>
                    <p className={`text-sm font-bold mb-2 ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>Modo de atualização</p>
                    <div className={`flex rounded-xl border overflow-hidden ${darkMode ? 'border-[#2d3748]' : 'border-slate-200'}`}>
                      {[
                        { value: 'scheduled', label: 'Horário fixo', desc: 'Uma vez por dia' },
                        { value: 'interval',  label: 'Intervalo',    desc: 'A cada N horas' },
                      ].map(opt => (
                        <button
                          key={opt.value}
                          onClick={() => setSysConfig(prev => ({ ...prev, update_mode: opt.value }))}
                          className={`flex-1 px-4 py-3 text-xs font-bold transition-all text-center ${
                            sysConfig.update_mode === opt.value
                              ? 'bg-blue-600 text-white'
                              : darkMode ? 'bg-[#1e2537] text-slate-400 hover:bg-[#1e293b]' : 'bg-white text-slate-500 hover:bg-slate-50'
                          }`}
                        >
                          {opt.label}
                          <span className={`block text-[10px] font-normal mt-0.5 ${sysConfig.update_mode === opt.value ? 'text-blue-200' : (darkMode ? 'text-slate-600' : 'text-slate-400')}`}>
                            {opt.desc}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Horário fixo */}
                  {sysConfig.update_mode === 'scheduled' && (
                    <div className="flex items-center justify-between">
                      <div>
                        <p className={`text-sm font-bold ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>Horário de atualização</p>
                        <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Roda uma vez por dia nesse horário</p>
                      </div>
                      <select
                        value={sysConfig.update_hour}
                        onChange={e => setSysConfig(prev => ({ ...prev, update_hour: e.target.value }))}
                        className={`px-3 py-2 rounded-xl text-sm font-bold outline-none border focus:ring-2 focus:ring-blue-500/20 ${darkMode ? 'bg-[#1e2537] border-[#2d3748] text-slate-200' : 'bg-slate-50 border-slate-200 text-slate-800'}`}
                      >
                        {Array.from({length:24}, (_,i) => String(i).padStart(2,'0')).map(h => (
                          <option key={h} value={h}>{h}:00</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Intervalo */}
                  {sysConfig.update_mode === 'interval' && (
                    <div className="flex items-center justify-between">
                      <div>
                        <p className={`text-sm font-bold ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>Intervalo entre consultas</p>
                        <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Consulta o Datajud repetidamente nesse intervalo</p>
                      </div>
                      <select
                        value={sysConfig.update_interval_hours}
                        onChange={e => setSysConfig(prev => ({ ...prev, update_interval_hours: e.target.value }))}
                        className={`px-3 py-2 rounded-xl text-sm font-bold outline-none border focus:ring-2 focus:ring-blue-500/20 ${darkMode ? 'bg-[#1e2537] border-[#2d3748] text-slate-200' : 'bg-slate-50 border-slate-200 text-slate-800'}`}
                      >
                        {[1,2,3,4,6,8,12,24].map(h => (
                          <option key={h} value={String(h)}>A cada {h}h</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Última atualização */}
                  {sysConfig.last_auto_update && (
                    <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Última atualização automática:{' '}
                      <span className="font-bold">
                        {new Date(sysConfig.last_auto_update).toLocaleString('pt-BR')}
                      </span>
                    </p>
                  )}

                  {/* Botões */}
                  <div className={`pt-4 border-t flex items-center justify-between ${darkMode ? 'border-[#1e293b]' : 'border-slate-100'}`}>
                    <button
                      onClick={async () => {
                        try {
                          await fetch(`${apiBaseUrl}/api/monitoramento/verificar`, { method: 'POST' });
                          setNotification({ type: 'success', message: 'Atualização manual iniciada!', visible: true });
                          setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                        } catch { }
                      }}
                      className={`text-sm font-bold px-4 py-2 rounded-xl border transition-all ${darkMode ? 'border-[#2d3748] text-slate-400 hover:bg-[#1e293b]' : 'border-slate-200 text-slate-600 hover:bg-slate-50'}`}
                    >
                      Atualizar agora
                    </button>
                    <button
                      disabled={configSaving}
                      onClick={async () => {
                        setConfigSaving(true);
                        try {
                          await fetch(`${apiBaseUrl}/api/config`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                              update_hour: sysConfig.update_hour,
                              update_enabled: sysConfig.update_enabled,
                              update_mode: sysConfig.update_mode,
                              update_interval_hours: sysConfig.update_interval_hours,
                            }),
                          });
                          setNotification({ type: 'success', message: 'Configurações salvas!', visible: true });
                          setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                        } catch {
                          setNotification({ type: 'error', message: 'Erro ao salvar.', visible: true });
                          setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                        } finally { setConfigSaving(false); }
                      }}
                      className="px-5 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-xl text-sm font-bold transition-all"
                    >
                      {configSaving ? 'Salvando…' : 'Salvar'}
                    </button>
                  </div>
                </div>
              </div>

              {/* Notificações por email */}
              <div className={`rounded-2xl border p-8 shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                    <Mail size={20} className="text-blue-600" />
                  </div>
                  <div>
                    <h3 className={`font-bold ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>Notificações por email</h3>
                    <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Alerta por email quando um prazo estiver próximo do vencimento.
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="space-y-1">
                    <label className={`text-xs font-bold uppercase tracking-wider ${darkMode ? 'text-slate-500' : 'text-slate-500'}`}>
                      Emails (separados por vírgula)
                    </label>
                    <input
                      type="text"
                      value={sysConfig.notif_emails}
                      onChange={e => setSysConfig(prev => ({ ...prev, notif_emails: e.target.value }))}
                      placeholder="advogado1@escritorio.com, advogado2@escritorio.com"
                      className={`w-full p-3 rounded-xl text-sm outline-none border focus:ring-2 focus:ring-blue-500/20 ${darkMode ? 'bg-[#1e2537] border-[#2d3748] text-slate-200' : 'bg-slate-50 border-slate-200 text-slate-800'}`}
                    />
                  </div>

                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`text-sm font-bold ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>Antecedência do alerta</p>
                      <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Quantos dias antes do vencimento enviar o email</p>
                    </div>
                    <select
                      value={sysConfig.notif_prazo_dias_antes}
                      onChange={e => setSysConfig(prev => ({ ...prev, notif_prazo_dias_antes: e.target.value }))}
                      className={`px-3 py-2 rounded-xl text-sm font-bold outline-none border focus:ring-2 focus:ring-blue-500/20 ${darkMode ? 'bg-[#1e2537] border-[#2d3748] text-slate-200' : 'bg-slate-50 border-slate-200 text-slate-800'}`}
                    >
                      {[1,2,3,5,7].map(d => (
                        <option key={d} value={String(d)}>{d} dia{d > 1 ? 's' : ''}</option>
                      ))}
                    </select>
                  </div>

                  <div className={`pt-4 border-t flex items-center justify-end ${darkMode ? 'border-[#1e293b]' : 'border-slate-100'}`}>
                    <button
                      disabled={notifEmailsSaving}
                      onClick={async () => {
                        setNotifEmailsSaving(true);
                        try {
                          await fetch(`${apiBaseUrl}/api/config`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                              notif_emails: sysConfig.notif_emails,
                              notif_prazo_dias_antes: sysConfig.notif_prazo_dias_antes,
                            }),
                          });
                          setNotification({ type: 'success', message: 'Configurações salvas!', visible: true });
                          setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                        } catch {
                          setNotification({ type: 'error', message: 'Erro ao salvar.', visible: true });
                          setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                        } finally { setNotifEmailsSaving(false); }
                      }}
                      className="px-5 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-xl text-sm font-bold transition-all"
                    >
                      {notifEmailsSaving ? 'Salvando…' : 'Salvar'}
                    </button>
                  </div>
                </div>
              </div>

              {/* Usuários (somente admin) */}
              {user?.role === 'administrador' && (
                <div className={`rounded-2xl border p-8 shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                        <UserCheck size={20} className="text-blue-600" />
                      </div>
                      <div>
                        <h3 className={`font-bold ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>Usuários</h3>
                        <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                          Cadastre e gerencie quem tem acesso ao sistema.
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => { setUsuarioForm({ nome: '', username: '', password: '', role: 'advogado' }); setUsuarioModal({}); }}
                      className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold transition-all"
                    >
                      <Plus size={16} /> Novo usuário
                    </button>
                  </div>

                  <div className="space-y-2">
                    {usuarios.length === 0 && (
                      <p className={`text-sm ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Nenhum usuário cadastrado ainda.</p>
                    )}
                    {usuarios.map((u) => (
                      <div key={u.id} className={`flex items-center justify-between p-3 rounded-xl border ${darkMode ? 'border-[#1e293b]' : 'border-slate-100'}`}>
                        <div>
                          <p className={`text-sm font-bold ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>{u.nome || u.username}</p>
                          <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>@{u.username} · {u.role}</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => { setUsuarioForm({ id: u.id, nome: u.nome || '', username: u.username, password: '', role: u.role }); setUsuarioModal(u); }}
                            className={`text-xs font-bold px-3 py-1.5 rounded-lg ${darkMode ? 'text-slate-300 hover:bg-[#1e293b]' : 'text-slate-600 hover:bg-slate-100'}`}
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => excluirUsuario(u)}
                            className="text-xs font-bold px-3 py-1.5 rounded-lg text-red-600 hover:bg-red-50"
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Extensão de navegador */}
              <div className={`rounded-2xl border p-8 shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                    <Globe size={20} className="text-blue-600" />
                  </div>
                  <div>
                    <h3 className={`font-bold ${darkMode ? 'text-slate-200' : 'text-slate-800'}`}>Extensão LexControl Capture</h3>
                    <p className={`text-xs mt-0.5 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Salve processos direto do PJe, e-SAJ ou TRF3 sem digitar nada manualmente.
                    </p>
                  </div>
                </div>

                <a
                  href={`${apiBaseUrl}/lexcontrol-capture.zip`}
                  download
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold transition-all"
                >
                  <Download size={16} /> Baixar extensão (.zip)
                </a>

                <div className={`mt-5 text-xs space-y-1.5 leading-relaxed ${darkMode ? 'text-slate-500' : 'text-slate-500'}`}>
                  <p className={`font-bold ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>Como instalar no Chrome:</p>
                  <p>1. Baixe o .zip acima e descompacte em uma pasta.</p>
                  <p>2. Abra <span className="font-mono">chrome://extensions</span> no navegador.</p>
                  <p>3. Ative "Modo do desenvolvedor" (canto superior direito).</p>
                  <p>4. Clique em "Carregar sem compactação" e selecione a pasta descompactada.</p>
                  <p>5. Clique no ícone da extensão na barra do navegador e faça login com seu usuário do LexControl.</p>
                </div>
              </div>

              {/* Info processos manuais */}
              <div className={`rounded-2xl border p-6 shadow-sm ${darkMode ? 'bg-[#161b27] border-[#1e293b]' : 'bg-white border-slate-200'}`}>
                <div className="flex items-start gap-3">
                  <AlertCircle size={18} className="text-amber-500 mt-0.5 shrink-0" />
                  <div>
                    <p className={`text-sm font-bold ${darkMode ? 'text-slate-200' : 'text-slate-700'}`}>Processos com atualização manual</p>
                    <p className={`text-xs mt-1 leading-relaxed ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Processos cadastrados manualmente (origem "Interno") não são atualizados automaticamente pelo Datajud.
                      Para ativá-los na atualização automática, edite o processo, informe o número CNJ no campo "Número Judicial" e ative o monitoramento com o ícone <Bell size={11} className="inline" />.
                    </p>
                    <p className={`text-xs mt-2 font-bold ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                      {processos.filter(p => p.origem !== 'Datajud').length} processo(s) marcados como atualização manual
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'reports' && (
            <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex items-center justify-between mb-2">
                <div>
                  <h2 className="text-2xl font-black text-slate-800">Relatorios Analiticos</h2>
                  <p className="text-slate-500 text-sm">Visualize o desempenho financeiro e operacional por filtro.</p>
                </div>
                <div className="relative export-dropdown">
                  <button 
                    onClick={() => setIsExportDropdownOpen(!isExportDropdownOpen)}
                    className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-xl text-sm font-bold hover:bg-slate-900 transition-all"
                  >
                    <Download size={16} /> Exportar
                  </button>
                  {isExportDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white border border-slate-200 rounded-xl shadow-lg z-10">
                      <button 
                        onClick={exportToPDF}
                        className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-t-xl"
                      >
                        Exportar como PDF
                      </button>
                      <button 
                        onClick={exportToExcel}
                        className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-b-xl"
                      >
                        Exportar como Excel
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                <div className="flex items-center gap-2 mb-5">
                  <Filter size={16} className="text-slate-500" />
                  <p className="text-sm font-bold text-slate-700">Filtros do Relatorio</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
                  <div>
                    <label className="text-[10px] font-black text-slate-400 uppercase mb-1 block">Data inicial</label>
                    <input
                      type="date"
                      value={reportDateFrom}
                      onChange={(e) => setReportDateFrom(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-slate-400 uppercase mb-1 block">Data final</label>
                    <input
                      type="date"
                      value={reportDateTo}
                      onChange={(e) => setReportDateTo(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-slate-400 uppercase mb-1 block">Status</label>
                    <select
                      value={reportStatus}
                      onChange={(e) => setReportStatus(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="Todos">Todos</option>
                      <option value="Ativo">Ativo</option>
                      <option value="Pendente">Pendente</option>
                      <option value="Concluído">Concluido</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-slate-400 uppercase mb-1 block">Tipo</label>
                    <select
                      value={reportTipo}
                      onChange={(e) => setReportTipo(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="Todos">Todos</option>
                      {reportTipos.map((tipo) => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-slate-400 uppercase mb-1 block">Cliente</label>
                    <select
                      value={reportCliente}
                      onChange={(e) => setReportCliente(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="Todos">Todos</option>
                      {reportClientes.map((cliente) => (
                        <option key={cliente} value={cliente}>{cliente}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <p className="text-xs font-medium text-slate-500">{reportMetricas.total} processo(s) encontrado(s)</p>
                  <button
                    onClick={() => {
                      setReportDateFrom('');
                      setReportDateTo('');
                      setReportStatus('Todos');
                      setReportTipo('Todos');
                      setReportCliente('Todos');
                    }}
                    className="px-4 py-2 text-sm font-bold rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50 transition-all"
                  >
                    Limpar filtros
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase mb-1">Processos</p>
                  <h4 className="text-xl font-black text-slate-800">{reportMetricas.total}</h4>
                </div>
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase mb-1">Valor Total</p>
                  <h4 className="text-xl font-black text-slate-800">R$ {reportMetricas.valorTotal.toLocaleString('pt-BR')}</h4>
                </div>
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase mb-1">Ticket Medio</p>
                  <h4 className="text-xl font-black text-slate-800">R$ {reportMetricas.mediaValor.toLocaleString('pt-BR')}</h4>
                </div>
                <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
                  <p className="text-[10px] font-black text-slate-400 uppercase mb-1">Taxa de Sucesso</p>
                  <h4 className="text-xl font-black text-emerald-600">{reportMetricas.taxaSucesso.toFixed(1)}%</h4>
                </div>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm">
                <h3 className="font-bold text-slate-800 mb-8 flex items-center gap-2">
                  <BarChart3 size={18} className="text-blue-600" /> Distribuicao por Natureza
                </h3>
                {reportMetricas.total === 0 ? (
                  <div className="px-4 py-6 rounded-xl bg-slate-50 text-sm text-slate-500">Nenhum processo encontrado para os filtros selecionados.</div>
                ) : (
                  <div className="space-y-6">
                    {Object.entries(reportMetricas.naturezaDist).map(([natureza, count]) => {
                      const percentage = reportMetricas.total ? (count / reportMetricas.total) * 100 : 0;
                      return (
                        <div key={natureza} className="space-y-2">
                          <div className="flex justify-between text-sm font-bold text-slate-700">
                            <span>{natureza}</span>
                            <span>{Math.round(percentage)}%</span>
                          </div>
                          <div className="w-full h-2.5 bg-slate-100 rounded-full overflow-hidden">
                            <div className="h-full bg-blue-500 rounded-full transition-all" style={{ width: `${percentage}%` }}></div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        {/* Notification Toast */}
        {notification.visible && (
          <div className={`fixed top-5 right-5 px-6 py-4 rounded-xl shadow-lg text-white font-bold text-sm animate-in fade-in slide-in-from-top-2 ${
            notification.type === 'success' ? 'bg-emerald-500' : 'bg-red-500'
          }`}>
            {notification.message}
          </div>
        )}

        {/* Modal Novo Cliente */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 animate-in zoom-in duration-200">
              <div className="flex items-center justify-between mb-8">
                <h3 className="text-xl font-bold text-slate-800">Novo Cliente</h3>
                <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-slate-100 rounded-full">
                  <X size={20} className="text-slate-400" />
                </button>
              </div>
              <div className="space-y-4">
                <div className="flex gap-2 p-1 bg-slate-100 rounded-xl mb-4">
                    <button
                      type="button"
                      onClick={() => setNewClienteTipo('PF')}
                      className={`flex-1 py-2 rounded-lg text-xs font-bold transition ${newClienteTipo === 'PF' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500'}`}
                    >
                      Pessoa Física
                    </button>
                    <button
                      type="button"
                      onClick={() => setNewClienteTipo('PJ')}
                      className={`flex-1 py-2 rounded-lg text-xs font-bold transition ${newClienteTipo === 'PJ' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500'}`}
                    >
                      Pessoa Jurídica
                    </button>
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Nome Completo / Razão Social</label>
                  <input
                    type="text"
                    value={newClienteNome}
                    onChange={(e) => setNewClienteNome(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="Ex: João da Silva"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">E-mail</label>
                  <input
                    type="email"
                    value={newClienteEmail}
                    onChange={(e) => setNewClienteEmail(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="exemplo@email.com"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Telefone</label>
                  <input
                    type="text"
                    value={newClienteTel}
                    onChange={(e) => setNewClienteTel(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="(11) 98888-7777"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Cidade</label>
                  <input
                    type="text"
                    value={newClienteCidade}
                    onChange={(e) => setNewClienteCidade(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="São Paulo, SP"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleSaveCliente}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-2xl shadow-lg shadow-blue-200 mt-4 active:scale-95 transition-transform"
                >
                  Salvar Cliente
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL NOVO PROCESSO */}
        {isProcessoModalOpen && (
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 animate-in zoom-in duration-200 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-8 sticky top-0 bg-white pb-4">
                <h3 className="text-xl font-bold text-slate-800">Novo Processo</h3>
                <button onClick={() => setIsProcessoModalOpen(false)} className="p-2 hover:bg-slate-100 rounded-full">
                  <X size={20} className="text-slate-400" />
                </button>
              </div>
              <div className="space-y-4">
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Cliente</label>
                  <select
                    value={newProcessoCliente}
                    onChange={(e) => setNewProcessoCliente(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="">Selecione um cliente</option>
                    {clientes.map(c => (
                      <option key={c.id} value={c.nome}>{c.nome}</option>
                    ))}
                  </select>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Tipo</label>
                    <select
                      value={newProcessoTipo}
                      onChange={(e) => setNewProcessoTipo(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="">Selecione o tipo</option>
                      <option value="Civil">Civil</option>
                      <option value="Penal">Penal</option>
                      <option value="Trabalhista">Trabalhista</option>
                      <option value="Tributário">Tributário</option>
                      <option value="Administrativo">Administrativo</option>
                      <option value="Ambiental">Ambiental</option>
                      <option value="Agrário">Agrário</option>
                      <option value="Comercial">Comercial</option>
                      <option value="Imobiliário">Imobiliário</option>
                      <option value="Família">Família</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Natureza</label>
                    <select
                      value={newProcessoNatureza}
                      onChange={(e) => setNewProcessoNatureza(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="">Selecione a natureza</option>
                      <option value="Cobrança">Cobrança</option>
                      <option value="Divórcio">Divórcio</option>
                      <option value="Indenização">Indenização</option>
                      <option value="Rescisão">Rescisão</option>
                      <option value="Guarda">Guarda</option>
                      <option value="Alimentos">Alimentos</option>
                      <option value="Despejo">Despejo</option>
                      <option value="Usucapião">Usucapião</option>
                      <option value="Inventário">Inventário</option>
                      <option value="Execução">Execução</option>
                      <option value="Recurso">Recurso</option>
                      <option value="Protesto">Protesto</option>
                      <option value="Ação Cível">Ação Cível</option>
                      <option value="Reclamação Trabalhista">Reclamação Trabalhista</option>
                      <option value="Processo Criminal">Processo Criminal</option>
                    </select>
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Origem do Processo</label>
                  <select
                    value={newProcessoOrigem}
                    onChange={(e) => setNewProcessoOrigem(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="Interno">Interno</option>
                    <option value="Judiciário">Do Judiciário</option>
                  </select>
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">📋 Número do Processo</label>
                  <input
                    type="text"
                    value={newProcessoNumeroJudicial}
                    onChange={(e) => setNewProcessoNumeroJudicial(e.target.value)}
                    placeholder="ex: 0012345-67.2023.8.19.0001"
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">📅 Data do Processo</label>
                  <input
                    type="date"
                    value={newProcessoData}
                    onChange={(e) => setNewProcessoData(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Status</label>
                    <select
                      value={newProcessoStatus}
                      onChange={(e) => setNewProcessoStatus(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Pendente">Pendente</option>
                      <option value="Concluído">Concluído</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 ml-1 uppercase tracking-wider">Valor (R$)</label>
                    <input
                      type="number"
                      value={newProcessoValor}
                      onChange={(e) => setNewProcessoValor(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                      placeholder="0,00"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleSaveProcesso}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-2xl shadow-lg shadow-blue-200 mt-4 active:scale-95 transition-transform"
                >
                  Cadastrar Processo
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL NOVO DOCUMENTO */}
        {docModal && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-3xl w-full max-w-2xl shadow-2xl flex flex-col max-h-[90vh] animate-in zoom-in duration-200">
              <div className="flex items-center justify-between p-8 pb-4 shrink-0">
                <h3 className="text-xl font-bold text-slate-800">Novo Documento</h3>
                <button onClick={() => setDocModal(false)} className="p-2 hover:bg-slate-100 rounded-full"><X size={20} className="text-slate-400" /></button>
              </div>
              <div className="flex-1 overflow-y-auto px-8 pb-8 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-1 col-span-2">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Título</label>
                    <input value={docTitulo} onChange={e => setDocTitulo(e.target.value)}
                      placeholder="Ex: Contrato de Honorários – João Silva"
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Tipo</label>
                    <select value={docTipo} onChange={e => setDocTipo(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20">
                      <option>Contrato</option>
                      <option>Procuração</option>
                      <option>Declaração</option>
                      <option>Acordo</option>
                      <option>Notificação Extrajudicial</option>
                      <option>Termo de Honorários</option>
                      <option>Outro</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Cliente</label>
                    <select value={docCliente} onChange={e => setDocCliente(e.target.value)}
                      className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20">
                      <option value="">Selecione (opcional)</option>
                      {clientes.map(c => <option key={c.id} value={c.nome}>{c.nome}</option>)}
                    </select>
                  </div>
                  <div className="space-y-1 col-span-2">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Conteúdo do Documento</label>
                    <textarea value={docConteudo} onChange={e => setDocConteudo(e.target.value)} rows={8}
                      placeholder={docArquivoBase64 ? '(PDF anexado — campo de texto ignorado)' : 'Digite o conteúdo completo do documento aqui...'}
                      disabled={!!docArquivoBase64}
                      className={`w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20 resize-none font-mono ${docArquivoBase64 ? 'opacity-40 cursor-not-allowed' : ''}`} />
                  </div>
                  <div className="space-y-1 col-span-2">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                      Ou anexar PDF <span className="text-slate-400 font-normal normal-case">(opcional — substitui o campo de texto)</span>
                    </label>
                    {docArquivoBase64 ? (
                      <div className="flex items-center gap-3 p-3 bg-emerald-50 border border-emerald-200 rounded-xl">
                        <CheckCircle size={16} className="text-emerald-600 shrink-0" />
                        <span className="text-sm text-emerald-700 font-medium flex-1 truncate">{docArquivoNome}</span>
                        <button onClick={() => { setDocArquivoBase64(''); setDocArquivoNome(''); }}
                          className="text-xs text-red-500 hover:text-red-700 font-bold shrink-0">Remover</button>
                      </div>
                    ) : (
                      <label className="flex items-center gap-3 p-3 bg-slate-50 border-2 border-dashed border-slate-300 rounded-xl cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all">
                        <FileSignature size={18} className="text-slate-400" />
                        <span className="text-sm text-slate-500">Clique para selecionar um PDF</span>
                        <input type="file" accept="application/pdf" className="hidden"
                          onChange={e => {
                            const file = e.target.files[0];
                            if (!file) return;
                            if (file.size > 8 * 1024 * 1024) {
                              setNotification({ type: 'error', message: 'PDF muito grande (máx. 8MB).', visible: true });
                              setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                              return;
                            }
                            const reader = new FileReader();
                            reader.onload = ev => {
                              const base64 = ev.target.result.split(',')[1];
                              setDocArquivoBase64(base64);
                              setDocArquivoNome(file.name);
                            };
                            reader.readAsDataURL(file);
                          }} />
                      </label>
                    )}
                  </div>
                </div>
                <button
                  onClick={async () => {
                    if (!docTitulo || (!docConteudo && !docArquivoBase64)) {
                      setNotification({ type: 'error', message: 'Preencha título e conteúdo, ou anexe um PDF.', visible: true });
                      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                      return;
                    }
                    const res = await fetch(`${apiBaseUrl}/api/documentos`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ titulo: docTitulo, tipo: docTipo, conteudo: docConteudo, cliente: docCliente, arquivo_base64: docArquivoBase64, arquivo_nome: docArquivoNome }),
                    });
                    if (res.ok) {
                      setDocModal(false);
                      setDocTitulo(''); setDocTipo('Contrato'); setDocConteudo(''); setDocCliente('');
                      setDocArquivoBase64(''); setDocArquivoNome('');
                      loadDocumentos();
                      setNotification({ type: 'success', message: 'Documento criado!', visible: true });
                      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                    }
                  }}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-2xl shadow-lg shadow-blue-200 active:scale-95 transition-transform"
                >
                  Salvar Documento
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL SOLICITAR ASSINATURA */}
        {docSigModal && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl animate-in zoom-in duration-200">
              <div className="flex items-center justify-between p-8 pb-4">
                <div>
                  <h3 className="text-xl font-bold text-slate-800">Solicitar Assinatura</h3>
                  <p className="text-xs text-slate-500 mt-1">{docSigModal.titulo}</p>
                </div>
                <button onClick={() => setDocSigModal(null)} className="p-2 hover:bg-slate-100 rounded-full"><X size={20} className="text-slate-400" /></button>
              </div>
              <div className="px-8 pb-8 space-y-4">
                {/* Assinaturas existentes */}
                {docAssinaturas.length > 0 && (
                  <div className="space-y-2">
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-wider">Signatários</p>
                    {docAssinaturas.map(a => (
                      <div key={a.id} className="flex items-center justify-between bg-slate-50 rounded-xl p-3">
                        <div>
                          <p className="text-sm font-bold text-slate-700">{a.signatario_nome}</p>
                          <p className="text-xs text-slate-400">{a.signatario_email}</p>
                        </div>
                        <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${
                          a.status === 'Assinado' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'
                        }`}>
                          {a.status === 'Assinado' ? '✓ Assinado' : '⏳ Pendente'}
                        </span>
                      </div>
                    ))}
                    <div className="border-t border-slate-100 pt-3 mt-2">
                      <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Adicionar Signatário</p>
                    </div>
                  </div>
                )}
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nome do Signatário</label>
                  <input value={sigNome} onChange={e => setSigNome(e.target.value)}
                    placeholder="Nome completo"
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Email</label>
                  <input type="email" value={sigEmail} onChange={e => setSigEmail(e.target.value)}
                    placeholder="email@exemplo.com"
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
                </div>
                <button
                  disabled={sigEnviando}
                  onClick={async () => {
                    if (!sigNome || !sigEmail) {
                      setNotification({ type: 'error', message: 'Preencha nome e email do signatário.', visible: true });
                      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                      return;
                    }
                    setSigEnviando(true);
                    try {
                      const res = await fetch(`${apiBaseUrl}/api/documentos/${docSigModal.id}/solicitar-assinatura`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ signatario_nome: sigNome, signatario_email: sigEmail }),
                      });
                      const data = await res.json();
                      if (res.ok) {
                        setSigNome(''); setSigEmail('');
                        loadDocumentos();
                        const sigRes = await fetch(`${apiBaseUrl}/api/documentos/${docSigModal.id}/assinaturas`);
                        if (sigRes.ok) setDocAssinaturas(await sigRes.json());
                        const msg = data.otp_simulado
                          ? `Solicitação enviada! (Email não configurado – OTP: ${data.otp_simulado})`
                          : `Email enviado para ${sigEmail}!`;
                        setNotification({ type: 'success', message: msg, visible: true });
                        setTimeout(() => setNotification(n => ({ ...n, visible: false })), 6000);
                      } else {
                        setNotification({ type: 'error', message: data.error || 'Erro ao enviar.', visible: true });
                        setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                      }
                    } finally { setSigEnviando(false); }
                  }}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-2xl shadow-lg shadow-blue-200 disabled:opacity-50 active:scale-95 transition-all"
                >
                  {sigEnviando ? 'Enviando...' : 'Enviar Solicitação de Assinatura'}
                </button>
                <p className="text-xs text-slate-400 text-center">O signatário receberá um email com o link e código OTP para assinar. Você pode adicionar quantos signatários precisar; quando todos assinarem, o documento final assinado é enviado por email a todos eles automaticamente.</p>
              </div>
            </div>
          </div>
        )}

        {/* MODAL ENVIAR DOCUMENTO POR EMAIL */}
        {docEnviarModal && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl animate-in zoom-in duration-200">
              <div className="flex items-center justify-between p-8 pb-4">
                <div>
                  <h3 className="text-xl font-bold text-slate-800">Enviar documento</h3>
                  <p className="text-xs text-slate-500 mt-1">{docEnviarModal.titulo}</p>
                </div>
                <button onClick={() => setDocEnviarModal(null)} className="p-2 hover:bg-slate-100 rounded-full"><X size={20} className="text-slate-400" /></button>
              </div>
              <div className="px-8 pb-8 space-y-4">
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Email do destinatário</label>
                  <input type="email" value={docEnviarEmail} onChange={e => setDocEnviarEmail(e.target.value)}
                    placeholder="email@exemplo.com"
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
                </div>
                <button
                  disabled={docEnviarSending}
                  onClick={async () => {
                    if (!docEnviarEmail) {
                      setNotification({ type: 'error', message: 'Informe o email do destinatário.', visible: true });
                      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 3000);
                      return;
                    }
                    setDocEnviarSending(true);
                    try {
                      const res = await fetch(`${apiBaseUrl}/api/documentos/${docEnviarModal.id}/enviar-email`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ email: docEnviarEmail }),
                      });
                      const data = await res.json();
                      if (res.ok) {
                        setDocEnviarModal(null); setDocEnviarEmail('');
                        setNotification({ type: 'success', message: `Documento enviado para ${docEnviarEmail}!`, visible: true });
                      } else {
                        setNotification({ type: 'error', message: data.error || 'Erro ao enviar.', visible: true });
                      }
                      setTimeout(() => setNotification(n => ({ ...n, visible: false })), 4000);
                    } finally { setDocEnviarSending(false); }
                  }}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-2xl shadow-lg shadow-blue-200 disabled:opacity-50 active:scale-95 transition-all"
                >
                  {docEnviarSending ? 'Enviando...' : 'Enviar por Email'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL DOSSIER CLIENTE */}
        {dossierCliente && (() => {
          const procs = processos.filter(p => p.cliente_id === dossierCliente.id || p.cliente === dossierCliente.nome);
          const totalValor = procs.reduce((s, p) => s + Number(p.valor || 0), 0);
          const ativos = procs.filter(p => p.status === 'Ativo').length;
          const concluidos = procs.filter(p => p.status === 'Concluído').length;
          const pendentes = procs.filter(p => p.status === 'Pendente').length;
          return (
            <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
              <div className="bg-white rounded-3xl w-full max-w-2xl shadow-2xl animate-in zoom-in duration-200 flex flex-col max-h-[90vh]">
                {/* Header */}
                <div className="flex items-start justify-between p-8 pb-6 border-b border-slate-100 shrink-0">
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${dossierCliente.tipo === 'PF' ? 'bg-blue-100 text-blue-600' : 'bg-indigo-100 text-indigo-600'}`}>
                      {dossierCliente.tipo === 'PF' ? <UserCheck size={28} /> : <Building2 size={28} />}
                    </div>
                    <div>
                      <h3 className="text-xl font-black text-slate-800">{dossierCliente.nome}</h3>
                      <span className={`text-[10px] font-black uppercase px-2 py-0.5 rounded-md ${dossierCliente.tipo === 'PF' ? 'bg-blue-100 text-blue-700' : 'bg-indigo-100 text-indigo-700'}`}>
                        {dossierCliente.tipo === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                      </span>
                    </div>
                  </div>
                  <button onClick={() => setDossierCliente(null)} className="p-2 hover:bg-slate-100 rounded-full">
                    <X size={20} className="text-slate-400" />
                  </button>
                </div>

                {/* Contato + métricas */}
                <div className="px-8 py-5 border-b border-slate-100 shrink-0">
                  <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500 mb-4">
                    {dossierCliente.email && <span className="flex items-center gap-1.5"><Mail size={12} />{dossierCliente.email}</span>}
                    {dossierCliente.tel && <span className="flex items-center gap-1.5"><Phone size={12} />{dossierCliente.tel}</span>}
                    {dossierCliente.cidade && <span className="flex items-center gap-1.5"><MapPin size={12} />{dossierCliente.cidade}</span>}
                  </div>
                  <div className="grid grid-cols-4 gap-3">
                    <div className="bg-slate-50 rounded-xl p-3 text-center">
                      <p className="text-[10px] font-bold text-slate-400 uppercase">Total</p>
                      <p className="text-lg font-black text-slate-800">{procs.length}</p>
                    </div>
                    <div className="bg-emerald-50 rounded-xl p-3 text-center">
                      <p className="text-[10px] font-bold text-emerald-500 uppercase">Ativos</p>
                      <p className="text-lg font-black text-emerald-700">{ativos}</p>
                    </div>
                    <div className="bg-amber-50 rounded-xl p-3 text-center">
                      <p className="text-[10px] font-bold text-amber-500 uppercase">Pendentes</p>
                      <p className="text-lg font-black text-amber-700">{pendentes}</p>
                    </div>
                    <div className="bg-blue-50 rounded-xl p-3 text-center">
                      <p className="text-[10px] font-bold text-blue-500 uppercase">Valor Total</p>
                      <p className="text-sm font-black text-blue-700">R$ {totalValor.toLocaleString('pt-BR')}</p>
                    </div>
                  </div>
                </div>

                {/* Lista de processos */}
                <div className="flex-1 overflow-y-auto px-8 py-5">
                  <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-3">Processos ({procs.length})</h4>
                  {procs.length === 0 ? (
                    <div className="text-center py-10 text-slate-400">
                      <Briefcase size={32} className="mx-auto mb-2 opacity-30" />
                      <p className="text-sm">Nenhum processo cadastrado</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {procs.map(p => {
                        const dueDate = parseProcessDate(p.data);
                        const hoje = new Date();
                        const diffDias = dueDate ? Math.ceil((dueDate - hoje) / (1000 * 60 * 60 * 24)) : null;
                        const urgente = diffDias !== null && diffDias >= 0 && diffDias <= 7;
                        return (
                          <div key={p.id} className={`rounded-2xl border p-4 ${urgente ? 'border-amber-200 bg-amber-50' : 'border-slate-100 bg-slate-50'}`}>
                            <div className="flex items-start justify-between gap-3">
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap mb-1">
                                  <span className="text-sm font-bold text-slate-800 truncate">{p.numero}</span>
                                  <span className={`text-[10px] font-black uppercase px-2 py-0.5 rounded-full ${
                                    p.status === 'Ativo' ? 'bg-emerald-100 text-emerald-700' :
                                    p.status === 'Pendente' ? 'bg-amber-100 text-amber-700' :
                                    'bg-slate-200 text-slate-600'
                                  }`}>{p.status}</span>
                                  {p.monitorar ? <span className="text-[10px] font-bold text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full flex items-center gap-1"><Bell size={9} /> Monitorado</span> : null}
                                </div>
                                <p className="text-xs text-slate-500">{p.tipo} · {p.natureza}</p>
                                {dueDate && (
                                  <p className={`text-xs mt-1 font-semibold ${urgente ? 'text-amber-700' : 'text-slate-400'}`}>
                                    📅 Prazo: {dueDate.toLocaleDateString('pt-BR')}
                                    {diffDias !== null && diffDias >= 0 && diffDias <= 30 && (
                                      <span className={`ml-1 ${urgente ? 'text-amber-600 font-bold' : 'text-slate-400'}`}>
                                        ({diffDias === 0 ? 'Hoje!' : diffDias === 1 ? 'Amanhã!' : `${diffDias} dias`})
                                      </span>
                                    )}
                                    {diffDias !== null && diffDias < 0 && <span className="ml-1 text-slate-400">(vencido)</span>}
                                  </p>
                                )}
                              </div>
                              <div className="text-right shrink-0">
                                <p className="text-sm font-black text-slate-800">R$ {Number(p.valor || 0).toLocaleString('pt-BR')}</p>
                                <p className="text-[10px] text-slate-400 mt-0.5">{p.data ? new Date(p.data).toLocaleDateString('pt-BR') : '-'}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Documentos do cliente */}
                {(() => {
                  const docs = documentos.filter(d => d.cliente === dossierCliente.nome);
                  if (docs.length === 0) return null;
                  return (
                    <div className="px-8 py-4 border-t border-slate-100 shrink-0">
                      <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-3">Documentos ({docs.length})</h4>
                      <div className="space-y-2 max-h-40 overflow-y-auto">
                        {docs.map(d => (
                          <div key={d.id} className="flex items-center justify-between bg-slate-50 rounded-xl px-3 py-2">
                            <div className="flex items-center gap-2 min-w-0">
                              <FileSignature size={14} className="text-slate-400 shrink-0" />
                              <div className="min-w-0">
                                <p className="text-sm font-semibold text-slate-700 truncate">{d.titulo}</p>
                                <p className="text-[10px] text-slate-400">{d.tipo} · {d.created_at ? new Date(d.created_at).toLocaleDateString('pt-BR') : '-'}</p>
                              </div>
                            </div>
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full shrink-0 ml-2 ${
                              d.status === 'Assinado' ? 'bg-emerald-100 text-emerald-700' :
                              d.status === 'Aguardando Assinatura' ? 'bg-amber-100 text-amber-700' :
                              'bg-slate-200 text-slate-600'
                            }`}>{d.status}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}
                {/* Footer */}
                <div className="px-8 py-4 border-t border-slate-100 shrink-0 flex justify-between items-center">
                  <p className="text-xs text-slate-400">Cliente desde {dossierCliente.created_at ? new Date(dossierCliente.created_at).toLocaleDateString('pt-BR') : '-'}</p>
                  <button onClick={() => setDossierCliente(null)} className="px-6 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-sm rounded-xl transition-all">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* MODAL CONFIRMAÇÃO DE PRAZO */}
        {usuarioModal && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 animate-in zoom-in duration-200">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-slate-800">{usuarioForm.id ? 'Editar usuário' : 'Novo usuário'}</h3>
                <button onClick={() => setUsuarioModal(null)} className="p-2 hover:bg-slate-100 rounded-full">
                  <X size={20} className="text-slate-400" />
                </button>
              </div>

              <div className="space-y-4 mb-6">
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nome</label>
                  <input
                    type="text"
                    value={usuarioForm.nome}
                    onChange={(e) => setUsuarioForm(f => ({ ...f, nome: e.target.value }))}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="Nome completo"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Usuário (login)</label>
                  <input
                    type="text"
                    value={usuarioForm.username}
                    disabled={!!usuarioForm.id}
                    onChange={(e) => setUsuarioForm(f => ({ ...f, username: e.target.value }))}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20 disabled:opacity-60"
                    placeholder="ex: joao.silva"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                    {usuarioForm.id ? 'Nova senha (deixe em branco para manter)' : 'Senha'}
                  </label>
                  <input
                    type="password"
                    value={usuarioForm.password}
                    onChange={(e) => setUsuarioForm(f => ({ ...f, password: e.target.value }))}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="••••••••"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Perfil</label>
                  <select
                    value={usuarioForm.role}
                    onChange={(e) => setUsuarioForm(f => ({ ...f, role: e.target.value }))}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="advogado">Advogado</option>
                    <option value="administrador">Administrador</option>
                  </select>
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => setUsuarioModal(null)}
                  className="flex-1 py-3 rounded-xl text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-all"
                >
                  Cancelar
                </button>
                <button
                  onClick={salvarUsuario}
                  disabled={usuarioSalvando}
                  className="flex-1 py-3 rounded-xl text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-60 transition-all"
                >
                  {usuarioSalvando ? 'Salvando…' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {prazoModal && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 animate-in zoom-in duration-200">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-xl font-bold text-slate-800">Confirmar Prazo Processual</h3>
                  <p className="text-xs text-slate-500 mt-1">{prazoModal.processo_numero}</p>
                </div>
                <button onClick={() => setPrazoModal(null)} className="p-2 hover:bg-slate-100 rounded-full">
                  <X size={20} className="text-slate-400" />
                </button>
              </div>

              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-6">
                <p className="text-sm font-bold text-amber-800 mb-1">
                  {prazoModal.prazo_tipo || 'Prazo identificado'}
                </p>
                <p className="text-xs text-amber-700 leading-relaxed">{prazoModal.descricao}</p>
                <p className="text-xs text-amber-600 mt-2 font-medium">Cliente: {prazoModal.cliente}</p>
              </div>

              <div className="space-y-4 mb-6">
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Quantidade de Dias</label>
                  <input
                    type="number"
                    min="1"
                    value={prazoEditDias}
                    onChange={(e) => setPrazoEditDias(e.target.value)}
                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20"
                    placeholder="Ex: 15"
                  />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Tipo de Contagem</label>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setPrazoEditContagem('uteis')}
                      className={`flex-1 py-2.5 rounded-xl text-xs font-bold border transition-all ${prazoEditContagem === 'uteis' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300'}`}
                    >
                      Dias Úteis (CPC)
                    </button>
                    <button
                      onClick={() => setPrazoEditContagem('corridos')}
                      className={`flex-1 py-2.5 rounded-xl text-xs font-bold border transition-all ${prazoEditContagem === 'corridos' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300'}`}
                    >
                      Dias Corridos (CLT)
                    </button>
                  </div>
                </div>
                {prazoEditDias && (
                  <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 text-center">
                    <p className="text-xs text-blue-600 font-medium">Previsão de vencimento</p>
                    <p className="text-sm font-bold text-blue-800 mt-0.5">
                      {calcularDataLimiteFrontend(prazoEditDias, prazoEditContagem)}
                    </p>
                    <p className="text-[10px] text-blue-500 mt-0.5">* Cálculo preciso com feriados feito ao confirmar</p>
                  </div>
                )}
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => { setPrazoModal(null); marcarNotifLida(prazoModal.id); }}
                  className="flex-1 py-3 rounded-2xl border border-slate-200 text-slate-600 text-sm font-bold hover:bg-slate-50 transition-all"
                >
                  Ignorar
                </button>
                <button
                  onClick={confirmarPrazo}
                  disabled={prazoSalvando || !prazoEditDias}
                  className="flex-1 py-3 rounded-2xl bg-blue-600 text-white text-sm font-bold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  {prazoSalvando ? 'Criando...' : 'Criar Tarefa e Agenda'}
                </button>
              </div>
            </div>
          </div>
        )}

        </div>
      </main>
    </div>
  );
};

const NavItem = ({ icon, label, active, onClick }) => (
  <button 
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-all ${
      active ? 'bg-blue-50 text-blue-600 shadow-sm shadow-blue-100/50' : 'text-slate-500 hover:bg-blue-50 hover:text-slate-800'
    }`}
  >
    {icon}
    <span>{label}</span>
    {active && <ChevronRight size={14} className="ml-auto opacity-60" />}
  </button>
);

const StatCard = ({ title, value, trend, positive, icon, color }) => (
  <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex flex-col gap-4">
    <div className="flex items-center justify-between">
      <div className={`p-3 rounded-xl ${color}`}>{icon}</div>
      <div className={`flex items-center gap-1 text-xs font-bold ${positive ? 'text-emerald-600' : 'text-rose-600'}`}>
        {positive ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />} {trend}
      </div>
    </div>
    <div>
      <p className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">{title}</p>
      <h3 className="text-2xl font-black text-slate-900 tracking-tight">{value}</h3>
    </div>
  </div>
);

const DeadlineItem = ({ title, date, urgency }) => (
  <div className="flex items-center justify-between p-4 rounded-xl bg-slate-50 border border-slate-100 hover:border-blue-100 transition-colors">
    <div className="flex flex-col">
      <span className="text-sm font-bold text-slate-700">{title}</span>
      <span className="text-[10px] font-medium text-slate-400 uppercase mt-0.5">{date}</span>
    </div>
    <div className={`w-2.5 h-2.5 rounded-full ring-4 ${
      urgency === 'high' ? 'bg-red-500 ring-red-100' : 
      urgency === 'medium' ? 'bg-amber-500 ring-amber-100' : 
      'bg-slate-300 ring-slate-100'
    }`}></div>
  </div>
);

const ExponentialChart = ({ data }) => {
  const maxValue = Math.max(...data.map(d => d.receita));
  const width = 500;
  const height = 250;
  const padding = 40;
  const chartWidth = width - 2 * padding;
  const chartHeight = height - 2 * padding;

  const points = data.map((d, i) => {
    const x = padding + (i / (data.length - 1)) * chartWidth;
    const y = height - padding - (d.receita / maxValue) * chartHeight;
    return { x, y, ...d };
  });

  const pathD = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');

  return (
    <svg width="100%" height={height} className="mt-4" viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2563eb" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#2563eb" stopOpacity="0" />
        </linearGradient>
      </defs>
      
      {/* Grid */}
      {[0, 1, 2, 3, 4].map(i => (
        <line
          key={`grid-${i}`}
          x1={padding}
          y1={height - padding - (chartHeight / 4) * i}
          x2={width - padding}
          y2={height - padding - (chartHeight / 4) * i}
          stroke="#e2e8f0"
          strokeWidth="1"
        />
      ))}

      {/* X-axis */}
      <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="#cbd5e1" strokeWidth="2" />
      
      {/* Y-axis */}
      <line x1={padding} y1={padding} x2={padding} y2={height - padding} stroke="#cbd5e1" strokeWidth="2" />

      {/* Chart area */}
      <path d={pathD} stroke="#2563eb" strokeWidth="3" fill="none" />
      <path d={pathD + ` L ${points[points.length - 1].x} ${height - padding} L ${padding} ${height - padding} Z`} fill="url(#gradient)" />

      {/* Points */}
      {points.map((p, i) => (
        <circle key={`point-${i}`} cx={p.x} cy={p.y} r="3" fill="#2563eb" />
      ))}

      {/* X-axis labels */}
      {[0, 3, 6, 9, 12].map(i => (
        <text
          key={`label-${i}`}
          x={points[i]?.x || 0}
          y={height - padding + 20}
          textAnchor="middle"
          fontSize="12"
          fill="#64748b"
        >
          {data[i]?.mes}
        </text>
      ))}

      {/* Y-axis labels */}
      {[0, 1, 2, 3, 4].map(i => {
        const value = Math.round((maxValue / 4) * i);
        return (
          <text
            key={`y-label-${i}`}
            x={padding - 10}
            y={height - padding - (chartHeight / 4) * i + 4}
            textAnchor="end"
            fontSize="12"
            fill="#64748b"
          >
            R$ {(value / 1000).toFixed(0)}k
          </text>
        );
      })}
    </svg>
  );
};

export default App;

